// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:12:06.946Z
// Property: Broad River Trace (ID: 6737460151192643)
// Collections: 33 amenities, 6 floorplans (live), 45 photos, 83 POIs, 4 reviews, 6 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192643",
  "property_external_id": "5026473",
  "property_zillow_url": "https://www.zillow.com/apartments/columbia-sc/broad-river-trace/5Xm8PX/",
  "property_apartments_url": "https://www.apartments.com/broad-river-trace-columbia-sc/chf8szg",
  "property_google_business_url": "https://www.google.com/maps/place/Broad+River+Trace/data=!4m2!3m1!1s0x0:0xa61fb3a91f644825?sa=X&ved=2ahUKEwj7hu2zzLySAxU3M1kFHcqaNegQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321225804",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "broad-river-trace",
  "property_name": "Broad River Trace",
  "property_website_url": "https://www.broadrivertrace.com/",
  "property_domain": "https://www.broadrivertrace.com/",
  "property_address": "551 Riverhill Cir",
  "property_full_address": "551 Riverhill Cir, Columbia, SC 29210",
  "property_address_1": "551 Riverhill Cir",
  "property_address_2": null,
  "property_address_city": "Columbia",
  "property_address_state": "SC",
  "property_address_zip_full": "29210-8156",
  "property_address_zip": "29210",
  "property_address_country": "US",
  "property_address_county": "Richland County",
  "property_neighborhood_address": "St Andrews",
  "property_address_latitude": "34.0219579",
  "property_address_longitude": "-81.07098110000001",
  "property_email": "broadrivertrace@rreafresidential.com",
  "property_phone": "(803) 933-9100",
  "property_call_tracking_phone": "803-220-3791",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Experience the vibrant lifestyle at Broad River Trace in Columbia, SC. Choose from cozy one, two, or three-bedroom apartments, and enjoy amenities like a stunning pool, pet park, and a 24-hour fitness center. With ample parking and controlled access, your perfect home awaits. Start your journey today!",
  "property_long_description": "**Welcome to Broad River Trace - Your Ideal Home Awaits in Columbia, SC!**\n\nDiscover the perfect blend of comfort and convenience at Broad River Trace, a premier apartment community situated in the heart of Columbia, SC. Our thoughtfully designed floor plans include one, two, and three-bedroom options, ensuring that we have a space that fits your lifestyle. \n\nEmbrace an array of luxurious amenities that elevate your living experience. Enjoy quality time with your furry friends at our pet-friendly Bark Park and pet park, or unwind by our two sparkling pools and gas fire pit. Stay active in our 24-hour fitness center, play a game on our outdoor sports court, or host gatherings in our stylish clubhouse outfitted with gas grills and a cozy clubroom.\n\nResidents benefit from unparalleled convenience with 24-hour on-call maintenance and management, online rent payment options, and ample on-site parking, including covered options. Additionally, our gated community ensures your peace of mind while offering beautiful views and direct access to the scenic Vulcan Trail.\n\nBroad River Trace also features essential services such as a business center equipped with modern facilities, car wash stations, and clothes care centers. Families will appreciate our two playgrounds, creating a welcoming environment for all ages.\n\nExplore our community today! Find your new home at Broad River Trace by browsing our availability or scheduling a tour to experience all we have to offer. Don’t miss the chance to elevate your lifestyle in Columbia—your ideal apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-52c8-7301-9897-657837218b89.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a green building in the background.",
    "public_id": "019e60e1-52c8-7301-9897-657837218b89",
    "storage_key": "property/6737460151192643/019e60e1-52c8-7301-9897-657837218b89.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "1998",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$175\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Please call our Leasing Office for complete Pet Policy information.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://broadrivertrace.loftliving.com/login",
  "property_apply_now_url": "https://8921437.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-8c36-708d-85d0-a8d3f2c4fa0b.webp",
  "property_primary_logo_media": {
    "alt_text": "Broad River Trace Apartment Homes logo",
    "public_id": "019e1dda-8c36-708d-85d0-a8d3f2c4fa0b",
    "storage_key": "property/6737460151192643/019e1dda-8c36-708d-85d0-a8d3f2c4fa0b.webp",
    "width": 1465,
    "height": 276
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-3b61-754f-b172-d1a91e5bd19c.webp",
  "property_secondary_logo_media": {
    "alt_text": "Broad River Trace Apartment Homes logo",
    "public_id": "019e1dda-3b61-754f-b172-d1a91e5bd19c",
    "storage_key": "property/6737460151192643/019e1dda-3b61-754f-b172-d1a91e5bd19c.webp",
    "width": 1465,
    "height": 276
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-3b61-754f-b172-d1a91e5bd19c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Broad River Trace Apartment Homes logo",
    "public_id": "019e1dda-3b61-754f-b172-d1a91e5bd19c",
    "storage_key": "property/6737460151192643/019e1dda-3b61-754f-b172-d1a91e5bd19c.webp",
    "width": 1465,
    "height": 276
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e8e86-e8e7-72fc-bae0-f6f81a78c0ee.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e86-e8e7-72fc-bae0-f6f81a78c0ee",
    "storage_key": "property/6737460151192643/019e8e86-e8e7-72fc-bae0-f6f81a78c0ee.webp",
    "width": 1280,
    "height": 241
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#053076",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "882 - 1295",
  "property_sqft_min": "882",
  "property_sqft_max": "1295",
  "property_price_range": "1158 - 1769",
  "property_price_min": "1158",
  "property_price_max": "1769",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/BroadRiverTraceApt",
  "property_instagram_url": "https://www.instagram.com/broad_river_trace/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJLz0FGaSk-IgRJUhkH6mzH6Y",
  "property_youtube_url": "https://www.youtube.com/watch?v=II4oqN3NKNk",
  "property_yelp_url": "https://www.yelp.com/biz/broad-river-trace-by-hamilton-point-investments-columbia",
  "property_tiktok_url": "https://www.tiktok.com/@broad.river.trace",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Broad River Trace",
  "property_home_romance_title": "Embrace the Life You Love in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Exceptional <a href=\"/floor-plans/\">1, 2, or 3 bedroom apartments</a> for rent with washer and dryer connections and modern appliances, including a dishwasher. Some of the best amenities are the beautiful hardwood floors, comfortable carpeting, and ample lighting to highlight <a href=\"/amenities/\">your home's best features</a> at Broad River Trace in Columbia, SC.</p>",
  "property_home_floorplans_blurb": "<p>Broad River Trace is located in Columbia, SC surrounded by <a href=\"/gallery/\">beautiful rivers</a> and lakes with a variety of restaurants, shopping, and entertainment just a few minutes away. Take a closer look at our neighborhood map and click on the categories for some popular points of interest nearby.</p>",
  "property_home_gallery_blurb": "At Broad River Trace in Columbia, SC, choose from stylish one, two, or three-bedroom floor plans that perfectly suit your lifestyle. Enjoy premium amenities like a sparkling pool, fitness center, and serene picnic areas. Picture yourself embracing vibrant community life while indulging in comfort and convenience—all within reach!",
  "property_home_neighborhood_blurb": "Nestled in charming Columbia, SC, Broad River Trace invites you to experience spacious one, two, and three-bedroom apartments that complement a vibrant lifestyle. Unearth local favorites and hidden gems in our lively neighborhood, all just steps away. Dive into the community’s rich offerings and see what makes this area truly special!",
  "property_home_reviews_blurb": "At Broad River Trace in Columbia, SC, tranquility meets top-notch community living. Residents rave about the “exceptional grounds upkeep” and “quick maintenance response,” ensuring a peaceful and well-maintained environment. Enjoy beautiful lake views, a relaxing pool, and friendly staff committed to your comfort. Experience the best of apartment living today!",
  "property_neighborhood_blurb": "<p>Broad River Trace is located in Columbia, SC surrounded by <a href=\"/gallery/\">beautiful rivers</a> and lakes with a variety of restaurants, shopping, and entertainment just a few minutes away. Take a closer look at our neighborhood map and click on the categories for some popular points of interest nearby.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>One look at the extraordinary amenities available and you’ll want to start packing your bags! You can get your daily workout at our 24-hour fully-equipped fitness center or swim a few laps in one of our <a href=\"/gallery/\">beautiful resort-style pools</a>. Keep your vehicle sparkling with our community car wash. Our resident pets can romp and play in their own dog park! Make your next move your best move to Broad River Trace apartments in Columbia, SC!</p>",
  "property_applynow_blurb": "At Broad River Trace in Columbia, SC, find your perfect space among stylish one, two, or three-bedroom floor plans. Indulge in modern amenities like a sparkling pool, pet park, and 24-hour fitness center, all within a gated community. Your ideal lifestyle awaits—lease online today!",
  "property_contactus_blurb": "At Broad River Trace in Columbia, SC, we offer a variety of thoughtfully designed floor plans—choose from one, two, or three-bedroom options to suit your lifestyle. Each home is a canvas for your unique style. Have questions? Contact our leasing team today for personalized assistance!",
  "property_faqs_blurb": "At Broad River Trace in Columbia, SC, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to your lifestyle. Have questions about our welcoming community? Visit our FAQs page to uncover helpful insights that make your living experience seamless and enjoyable. Your perfect home awaits!",
  "property_floorplans_blurb": "<p>At Broad River Trace, you’ll find spacious one, two, and three bedroom contemporary apartments for rent with <a href=\"/amenities/\">wonderful amenities</a>. From here, you can search for a floor plan by apartment number, maximum rent, or the number of bedrooms and bathrooms. Find your next new home in Columbia, SC here!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Broad River Trace in Columbia, SC, your ideal home awaits with spacious one-, two-, and three-bedroom floor plans. Enjoy a vibrant community featuring a sparkling swimming pool, pet-friendly amenities, and a 24-hour fitness center. Use our interactive community map to effortlessly find your new sanctuary today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Broad River Trace in Columbia, SC, we believe great friends make great neighbors! Our diverse floor plans—one, two, and three-bedroom options—offer the perfect backdrop for your next chapter. Share the experience and refer a friend to join our vibrant community today! ",
  "property_residentaccess_blurb": "Welcome to Broad River Trace in Columbia, SC, where comfort meets convenience. From our thoughtfully designed one, two, and three-bedroom floor plans to our resident portal, everything you need is just a click away. Access your portal to pay rent, schedule maintenance, and enhance your living experience today!",
  "property_reviews_blurb": "At Broad River Trace in Columbia, SC, residents enjoy a serene atmosphere and exceptional service. With beautifully maintained grounds, a sparkling pool, and responsive maintenance staff, it’s no wonder our community shines. One resident shares, \"It’s calm, peaceful, and quiet.” Experience the best of apartment living at Broad River Trace!",
  "property_created_at": "1752257258959",
  "property_scheduletour_blurb": "At Broad River Trace in Columbia, SC, your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Curious about life here? Schedule a tour and hear firsthand from our residents about the vibrant community that welcomes you with open arms!",
  "property_thankyou_blurb": "Thank you for reaching out to Broad River Trace in vibrant Columbia, SC! Our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—perfectly cater to your lifestyle. A team member will connect with you soon to help make your dream home a reality. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "<p>At Broad River Trace, we make finding your new home quick & easy with our beautiful virtual tour. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Broad River Trace",
  "property_seo_title_home": "Broad River Trace | Apartments in Columbia, SC",
  "property_seo_description_home": "\"Welcome to Broad River Trace, your retreat in Columbia, SC, where comfort meets convenience. Choose from spacious one to three-bedroom floor plans, each designed for modern living. Enjoy top-notch amenities including a sparkling pool, fitness center, pet park, and gas fire pits. Experience hassle-free living with 24/7 management, online rent payment, and ample parking. Ready to elevate your lifestyle? Your ideal home awaits!\"",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Columbia, SC",
  "property_seo_description_floorplans": "Find your ideal living space at Broad River Trace in Columbia, SC! With thoughtfully designed one, two, and three-bedroom floor plans, each apartment caters to your lifestyle and preferences. Whether you seek cozy comfort or spacious elegance, our diverse layouts offer something for everyone. Browse our available apartment homes today and envision your new beginning!",
  "property_seo_title_amenities": "Amenities | Columbia, SC Apartments for Rent",
  "property_seo_description_amenities": "\"Welcome to Broad River Trace in Columbia, SC, where modern living meets ultimate convenience. Choose from spacious one, two, and three-bedroom floor plans and enjoy a plethora of amenities including a sparkling swimming pool, vibrant pet park, and state-of-the-art fitness center. With features like gas grills, covered parking, a business center, and 24/7 on-call maintenance, life here ensures comfort and ease. Unwind by the gas fire pit, stay active on the basketball court, and experience the charm of our gated community. Your perfect home awaits – get ready to elevate your lifestyle!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Columbia, SC",
  "property_seo_description_gallery": "\"At Broad River Trace in Columbia, SC, every corner tells a story. With floor plans to suit every lifestyle—including one, two, and three-bedroom options—our community invites you to unwind amidst resort-style amenities. Picture yourself lounging by one of our sparkling pools, enjoying a barbecue at the gas grills, or playing fetch at our pet-friendly dog park. Plus, enjoy peace of mind with 24/7 management and maintenance. Transform your living experience today—hint: your new home is just a click away!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Broad River Trace Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Broad River Trace in Columbia, SC! Our stunning virtual tour invites you to stroll through our one, two, and three-bedroom floor plans, each designed for comfort and style. Unveil the lifestyle waiting for you—take your virtual tour of our community and find your perfect home today!",
  "property_seo_title_interactivemap": "Interactive Map | Broad River Trace Apartments",
  "property_seo_description_interactivemap": "Experience the vibrant lifestyle at Broad River Trace in Columbia, SC, where modern comfort meets exceptional amenities. Choose from our spacious one, two, and three-bedroom floor plans and enjoy features like a sparkling swimming pool, 24-hour fitness center, pet park, and convenient online rent payment. With access to scenic Vulcan trail, a gated community, and a welcoming clubhouse, your perfect apartment awaits. Use our interactive community map to effortlessly find your new home and check out our competitive pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Columbia, SC",
  "property_seo_description_neighborhood": "Experience the vibrant neighborhood surrounding Broad River Trace in Columbia, SC. From charming eateries to scenic parks, uncover local favorites and hidden gems just steps from your door. Delve into the community's unique offerings and see how you can enjoy life to the fullest in our diverse one, two, and three-bedroom apartments. Your next adventure awaits!",
  "property_seo_title_contact": "Contact Us | Broad River Trace",
  "property_seo_description_contact": "Reach out to the leasing team at Broad River Trace in Columbia, SC, where spacious one, two, and three-bedroom floor plans await your ideal lifestyle. Whether you're seeking upscale amenities or a vibrant community atmosphere, we're here to answer all your questions. Connect with us today and unlock the door to your new home!",
  "property_seo_title_faqs": "FAQs | Apartments in Columbia, SC",
  "property_seo_description_faqs": "\"At Broad River Trace in Columbia, SC, we go beyond just living spaces with one to three-bedroom floor plans that suit your lifestyle. Our vibrant community boasts top-notch amenities including a pet-friendly park, two sparkling pools, a fitness center, and even a gas fire pit for cozy evenings. Need answers? Visit our FAQs page to uncover everything you need to know about making Broad River Trace your new home. Your perfect living experience awaits!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Columbia, SC",
  "property_seo_description_reviews": "\"At Broad River Trace in Columbia, SC, residents enjoy a vibrant community filled with modern amenities, including a sparkling swimming pool, pet parks, and a state-of-the-art fitness center. Explore spacious one, two, and three-bedroom floor plans, all backed by 24/7 onsite management and maintenance. Dive into the experiences shared by our residents and see why our gated community feels like home. Join our community today!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Columbia, SC",
  "property_seo_description_applynow": "Experience the blend of comfort and convenience at Broad River Trace in Columbia, SC. Choose from spacious one, two, or three-bedroom floor plans designed for modern living. Enjoy an array of amenities including a sparkling swimming pool, 24-hour fitness center, and a pet park for your furry friends. With gated access, on-site management, and online rent payment, your peace of mind is our priority. Embrace the vibrant community lifestyle with gas grills, a clubhouse, and direct access to the scenic Vulcan trail. Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Broad River Trace",
  "property_seo_description_residentaccess": "Unlock the convenience of Broad River Trace! Log in to your resident portal to manage rent payments, schedule maintenance, and connect with your community—all from the comfort of your home in beautiful Columbia, SC. Your comfortable lifestyle awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Broad River Trace",
  "property_seo_description_referafriend": "\"At Broad River Trace in Columbia, SC, friendships flourish just like our vibrant community. Share the joy of your home and refer a friend today—because great friends make the best neighbors! Join us in creating a welcoming space where memories are made.\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Broad River Trace",
  "property_seo_description_scheduletour": "Experience the charm of Broad River Trace in Columbia, SC, where luxurious living meets serene surroundings. Immerse yourself in our vibrant community and envision your future home. Ready to take the first step? Schedule a tour today and uncover what makes us unique!",
  "property_seo_title_privacy": "Privacy Policy | Broad River Trace",
  "property_seo_description_privacy": "\"At Broad River Trace in Columbia, SC, your privacy matters. Learn how we safeguard your personal information and provide a secure living environment. View our privacy policy to see our commitment to your peace of mind.\"",
  "property_seo_title_accessibility": "Website Accessibility | Broad River Trace",
  "property_seo_description_accessibility": "\"At Broad River Trace in Columbia, SC, we embrace digital inclusivity for all. Our Accessibility Statement highlights our commitment to providing an enjoyable online experience for every visitor. Join our community where everyone feels welcomed!\"",
  "property_seo_title_sitemap": "Sitemap | Broad River Trace",
  "property_seo_description_sitemap": "\"Navigate your journey to your next home at Broad River Trace in Columbia, SC. Our sitemap offers a clear path to amenities, floor plans, and community features that make us uniquely inviting. Unearth every detail—your new beginning starts here!\"",
  "property_seo_title_thankyou": "Thank You | Broad River Trace",
  "property_seo_description_thankyou": "Thank you for reaching out to Broad River Trace! Your inquiry is in good hands. We'll be in touch soon to help you find your perfect Columbia, SC apartment. Stay tuned for exciting updates about our vibrant community!",
  "property_seo_title_pets": "Pet Policy | Apartments in Columbia, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293640950",
  "amenities": [
    {
      "id": "custom_4723a0f5-54fe-485b-8a1c-f801e96857dc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Resort-style Swimming Pools",
      "amount": "false",
      "description": "Beautiful resort‑style pools for residents to swim and relax.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f6b3bb5-180e-45a5-acca-2868d969a629",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Fully‑equipped, 24‑Hour Fitness Center",
      "amount": "false",
      "description": "A fitness center accessible 24 hours and fully equipped.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e060c816-dbe5-4d61-96a8-eb1444c5ea41",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "Convenient option to pay rent online.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c41507dc-d547-44dd-8d67-14a7a0178e32",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "Private balconies or patios available in apartments.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13e0b28d-6efb-4f0b-849e-69792e07f6e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Pond and Nature Views Available",
      "amount": "false",
      "description": "Options for units or views overlooking ponds and natural scenery.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_74436d25-8ea2-4332-8ccb-e49373647f47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "On‑site business center for residents.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df5837a5-fb4c-4a05-a30a-f30c9612a03c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "Community clubhouse for gatherings and resident use.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_07a3006f-6a16-4584-a59b-41bc94683d31",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "On‑site coffee and tea bar amenity.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77cf6abb-ffa6-4248-a2ca-bebcc03c33e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Community Car Wash",
      "amount": "false",
      "description": "Car wash facility available to residents within the community.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d3633cf-e69d-499c-bd05-d54a044b198a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "Dedicated dog park for resident pets to play.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f3a1016a-7fe7-4090-b264-7f28c05beee8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Gorgeous Pond",
      "amount": "false",
      "description": "Scenic pond on property for enjoyment.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5ef73e4-c54a-46a4-a03f-e48102e5b9f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "Maintenance staff available on-site.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c91af2a-2e20-4421-86a7-052f59c39af9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Management",
      "amount": "false",
      "description": "Management office located within the community.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_123a41ac-7be1-4e90-9945-2c691701c2f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑friendly",
      "amount": "false",
      "description": "Community allows pets with supportive amenities.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8644223-885e-4d67-8ee8-dd1a35ad9c0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "Organized events for residents.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_297bb03e-f469-4e90-8a66-0a1f8a9b8118",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9da76a1c-39cf-482a-8d76-a7a6a4c28300",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Ample Lighting",
      "amount": "false",
      "description": "Apartments designed with abundant lighting.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8fc888e2-7bdc-403b-b0b8-a974f0b07c49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "Private balconies or patios included in apartments.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc5f2948-4ebb-4970-9629-edd767f231db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Comfortable Carpeted and Hardwood Floors",
      "amount": "false",
      "description": "Combination of carpet and hardwood-style flooring in units.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54883045-3c02-4406-b83f-36ba584feb9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "Modern dishwasher included in apartment kitchens.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff598b08-2f19-40f9-9ad4-f767ecb076d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Bar Countertop",
      "amount": "false",
      "description": "Kitchen bar-style countertop feature.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d2fb3c0-4e12-42fa-9267-ca3c41f690b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Kitchen Appliances",
      "amount": "false",
      "description": "Contemporary appliance package in units.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_451990bc-f250-499c-b869-a5b8c35ab00f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "Option to pay rent online—listed here and also in community amenities.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b10c4737-f5fd-485a-a633-0d616d6a66f8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Oven with Stovetop",
      "amount": "false",
      "description": "Standard oven and stovetop included.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fdbe985e-b995-4bbd-a34a-afac6ad95921",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "Refrigerator included in each unit.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_07d63a57-3991-499f-9133-b48964314e49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer",
      "amount": "false",
      "description": "Washer and dryer connections provided.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d20f5581-d374-44a0-83e1-1ef6594faa8c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "In renovated units—upgraded stainless steel appliances.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7211b9f-3970-4b70-a64a-2428ab9ccbbb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood style flooring",
      "amount": "false",
      "description": "Hardwood-style floors in renovated apartment homes.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_676e1f44-2675-4f06-82bc-50f630b7889b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Gooseneck Faucet with sprayer",
      "amount": "false",
      "description": "Modern gooseneck kitchen faucet with sprayer in renovated units.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f587d729-8de8-40d3-a0a4-24f9921ff0fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "New lighting fixtures",
      "amount": "false",
      "description": "Updated lighting fixtures in renovated apartments.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5cad6866-70df-4561-9351-1c0e5573fac7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "New Hardware throughout",
      "amount": "false",
      "description": "Refreshed hardware throughout renovated units.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f416cf6f-8380-4ccb-b84a-442690630d72",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "Vaulted ceilings available in select units.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4bc16bb1-ee7c-4cff-b008-69f92581a0f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace*",
      "amount": "false",
      "description": "Fireplace available in select units.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2b2bd1be-6db2-477d-82a5-f1c7d0b1eea3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019fb36f-d26e-76c0-a1d7-1ca62374d74b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and pergolas.",
        "public_id": "019fb36f-d26e-76c0-a1d7-1ca62374d74b",
        "storage_key": "property/6737460151192643/019fb36f-d26e-76c0-a1d7-1ca62374d74b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool, complete with comfortable lounge chairs and shaded pergolas for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and pergolas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3f250f2-3060-4e5c-96b7-85f588aebf8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019fb36f-d264-71fd-85be-72975571aa87.webp",
      "image_media": {
        "alt_text": "Covered porch with rocking chairs and ceiling fans",
        "public_id": "019fb36f-d264-71fd-85be-72975571aa87",
        "storage_key": "property/6737460151192643/019fb36f-d264-71fd-85be-72975571aa87.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind on the spacious covered porch, complete with comfortable rocking chairs and ceiling fans for your enjoyment.",
      "link": "",
      "alt_text": "Covered porch with rocking chairs and ceiling fans",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f2e1455-1419-466b-bc59-895aeccc4b90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-3bbb-7508-a2ff-820bef01f108.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019e60e1-3bbb-7508-a2ff-820bef01f108",
        "storage_key": "property/6737460151192643/019e60e1-3bbb-7508-a2ff-820bef01f108.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this bright and airy kitchen, featuring sleek white cabinetry, gleaming stainless steel appliances, and elegant marble countertops. Perfect for preparing your favorite meals.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_378cff71-6dac-4ffd-b433-6637027132d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-2951-763d-a0ba-74be2bc5f58a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, a desk, and a ceiling fan.",
        "public_id": "019e60e1-2951-763d-a0ba-74be2bc5f58a",
        "storage_key": "property/6737460151192643/019e60e1-2951-763d-a0ba-74be2bc5f58a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "A comfortable bedroom featuring a queen-size bed with decorative pillows, a white desk with a yellow chair, and a ceiling fan for climate control.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, a desk, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67cfe114-9bce-43ae-b6db-d88316eb5874",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019fb36f-d344-771d-9c94-bcc990a69b3a.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, stationary bikes, and free weights.",
        "public_id": "019fb36f-d344-771d-9c94-bcc990a69b3a",
        "storage_key": "property/6737460151192643/019fb36f-d344-771d-9c94-bcc990a69b3a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, stationary bikes, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_474d868a-939d-40cc-9429-a15a8384b44c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-4239-727b-b814-269c9f9f5ab5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a double sink.",
        "public_id": "019e60e1-4239-727b-b814-269c9f9f5ab5",
        "storage_key": "property/6737460151192643/019e60e1-4239-727b-b814-269c9f9f5ab5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring white cabinetry, stainless steel appliances, granite countertops, and a double sink, perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c4064be-8ed5-4c19-9d07-5155185c0ea6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-3503-759a-9153-9f930e5a8a24.webp",
      "image_media": {
        "alt_text": "Living room with beige sofa, blue accent chair, coffee table, and balcony access.",
        "public_id": "019e60e1-3503-759a-9153-9f930e5a8a24",
        "storage_key": "property/6737460151192643/019e60e1-3503-759a-9153-9f930e5a8a24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, elegant accent chair, and a coffee table, perfect for relaxation and entertaining. Access your private balcony through sliding glass doors.",
      "link": "",
      "alt_text": "Living room with beige sofa, blue accent chair, coffee table, and balcony access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31aec508-18fc-4fe8-9315-6688bb734613",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019fb36f-d6c9-7671-a0d0-d298375e3637.webp",
      "image_media": {
        "alt_text": "Seating area with coffee station overlooking the exterior.",
        "public_id": "019fb36f-d6c9-7671-a0d0-d298375e3637",
        "storage_key": "property/6737460151192643/019fb36f-d6c9-7671-a0d0-d298375e3637.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a complimentary coffee while taking in the serene views from our community's charming seating area.",
      "link": "",
      "alt_text": "Seating area with coffee station overlooking the exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_968d39b5-f49c-4b42-9390-48bd38ae8f35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-52c8-7301-9897-657837218b89.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a green building in the background.",
        "public_id": "019e60e1-52c8-7301-9897-657837218b89",
        "storage_key": "property/6737460151192643/019e60e1-52c8-7301-9897-657837218b89.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, perfect for a sunny afternoon. Enjoy the beautiful surroundings and unwind in style.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a green building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6bfa81eb-ca8a-401a-aa4b-fd1e8c365222",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-5100-7447-aac6-d64791d945bc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e60e1-5100-7447-aac6-d64791d945bc",
        "storage_key": "property/6737460151192643/019e60e1-5100-7447-aac6-d64791d945bc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29f7fd20-bf1f-4c27-8b76-a32ad71010bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019fb36f-d34d-70eb-b4d3-f4ea84937a48.webp",
      "image_media": {
        "alt_text": "Lobby with seating area, coffee station, and artwork.",
        "public_id": "019fb36f-d34d-70eb-b4d3-f4ea84937a48",
        "storage_key": "property/6737460151192643/019fb36f-d34d-70eb-b4d3-f4ea84937a48.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax in our comfortable lobby, featuring a coffee station and vibrant artwork.",
      "link": "",
      "alt_text": "Lobby with seating area, coffee station, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd1471ea-c544-4f1f-9b09-e9f9181c0999",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-4f57-71d9-b228-e4d25ab026ea.webp",
      "image_media": {
        "alt_text": "Fitness center with weights, cable machine, and water cooler.",
        "public_id": "019e60e1-4f57-71d9-b228-e4d25ab026ea",
        "storage_key": "property/6737460151192643/019e60e1-4f57-71d9-b228-e4d25ab026ea.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of weights, cardio machines, and a cable crossover machine.",
      "link": "",
      "alt_text": "Fitness center with weights, cable machine, and water cooler.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_98fa771a-05d3-4c4c-87bf-cb3d4730ce35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-4548-75ca-a833-6ef047325481.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer",
        "public_id": "019e60e1-4548-75ca-a833-6ef047325481",
        "storage_key": "property/6737460151192643/019e60e1-4548-75ca-a833-6ef047325481.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Use our convenient business center to print, copy, or scan documents.",
      "link": "",
      "alt_text": "Business center with computers and printer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_027fdc8f-aa4c-4abc-af15-12949ab9ada3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-40d9-7149-b536-dcfc00158837.webp",
      "image_media": {
        "alt_text": "Bedroom with sliding glass door to patio and walk-in closet",
        "public_id": "019e60e1-40d9-7149-b536-dcfc00158837",
        "storage_key": "property/6737460151192643/019e60e1-40d9-7149-b536-dcfc00158837.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting, a ceiling fan, and a sliding glass door leading to a private patio. Includes a convenient walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with sliding glass door to patio and walk-in closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f3c83e7-89fe-492a-9c9d-f6a7613e4d00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-407f-7512-9251-111823d50229.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room with balcony access",
        "public_id": "019e60e1-407f-7512-9251-111823d50229",
        "storage_key": "property/6737460151192643/019e60e1-407f-7512-9251-111823d50229.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area with a modern kitchen featuring stainless steel appliances and a breakfast bar, opening to a private balcony.",
      "link": "",
      "alt_text": "Modern kitchen and living room with balcony access",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_47bdece7-7ce0-4cb1-8d07-5c6feb1072fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-4392-7057-b287-1c01227b92da.webp",
      "image_media": {
        "alt_text": "Spacious communal lounge area with a fireplace, seating, and a bar.",
        "public_id": "019e60e1-4392-7057-b287-1c01227b92da",
        "storage_key": "property/6737460151192643/019e60e1-4392-7057-b287-1c01227b92da.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting communal lounge, featuring a cozy fireplace, comfortable seating areas, and a convenient bar for socializing.",
      "link": "",
      "alt_text": "Spacious communal lounge area with a fireplace, seating, and a bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e0a3685-beb4-4cf7-a307-4a21764e7d28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-3975-7088-885c-00d94accfce5.webp",
      "image_media": {
        "alt_text": "A sparkling blue swimming pool with lounge chairs and a light green building in the background.",
        "public_id": "019e60e1-3975-7088-885c-00d94accfce5",
        "storage_key": "property/6737460151192643/019e60e1-3975-7088-885c-00d94accfce5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by lush greenery and comfortable lounge seating.",
      "link": "",
      "alt_text": "A sparkling blue swimming pool with lounge chairs and a light green building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_32121769-29e6-4c36-9854-0ab7467f48b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-378a-7275-b8f5-45d45825f7a3.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, dumbbells, and benches.",
        "public_id": "019e60e1-378a-7275-b8f5-45d45825f7a3",
        "storage_key": "property/6737460151192643/019e60e1-378a-7275-b8f5-45d45825f7a3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of weight machines, free weights, and cardio equipment.",
      "link": "",
      "alt_text": "Fitness center with weight machines, dumbbells, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24072596-736f-42e9-bb76-694d4ed9aeaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-3c7f-7505-ae1d-d1f6c0ca3e01.webp",
      "image_media": {
        "alt_text": "Washer and dryer with a shelf above",
        "public_id": "019e60e1-3c7f-7505-ae1d-d1f6c0ca3e01",
        "storage_key": "property/6737460151192643/019e60e1-3c7f-7505-ae1d-d1f6c0ca3e01.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer provide convenient laundry facilities, with a storage shelf overhead for extra space.",
      "link": "",
      "alt_text": "Washer and dryer with a shelf above",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a734515a-20fb-4a5f-9455-5fa1e4b2896a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-2d01-73a9-96b8-d896a6ecbaa5.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and ceiling fan.",
        "public_id": "019e60e1-2d01-73a9-96b8-d896a6ecbaa5",
        "storage_key": "property/6737460151192643/019e60e1-2d01-73a9-96b8-d896a6ecbaa5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, ample storage, and a soothing ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_69780c18-b30b-46c0-8d26-e81ea08a943c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-24bf-741a-9ad9-369763b18587.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and trees",
        "public_id": "019e60e1-24bf-741a-9ad9-369763b18587",
        "storage_key": "property/6737460151192643/019e60e1-24bf-741a-9ad9-369763b18587.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and surrounded by lush trees, perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f46855cc-81ab-469f-8adc-b02ba7973773",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-2871-7767-bd00-cb77c49be06e.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer",
        "public_id": "019e60e1-2871-7767-bd00-cb77c49be06e",
        "storage_key": "property/6737460151192643/019e60e1-2871-7767-bd00-cb77c49be06e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay connected with our convenient business center, featuring computers and a printer for all your work and printing needs.",
      "link": "",
      "alt_text": "Business center with computers and printer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f800dd0-9fea-4336-bed4-433fe6c994c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-2309-75dc-b70f-0ac17877c22e.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a fireplace, seating areas, and a business center.",
        "public_id": "019e60e1-2309-75dc-b70f-0ac17877c22e",
        "storage_key": "property/6737460151192643/019e60e1-2309-75dc-b70f-0ac17877c22e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace, comfortable seating, and a convenient business center for all your work needs.",
      "link": "",
      "alt_text": "Spacious community lounge with a fireplace, seating areas, and a business center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3f21f04-721d-472e-ab10-45f64c1734a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-258f-701b-84ce-422373137805.webp",
      "image_media": {
        "alt_text": "Clean and bright bathroom with a white bathtub, colorful shower curtain, toilet, and vanity with a marble-look countertop.",
        "public_id": "019e60e1-258f-701b-84ce-422373137805",
        "storage_key": "property/6737460151192643/019e60e1-258f-701b-84ce-422373137805.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a clean and bright bathroom featuring a relaxing white bathtub, a vibrant, colorful shower curtain, a modern toilet, and a chic vanity with a marble-look countertop.",
      "link": "",
      "alt_text": "Clean and bright bathroom with a white bathtub, colorful shower curtain, toilet, and vanity with a marble-look countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9d71700-658c-4830-936f-2893536fdb6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-2118-725a-ae2c-7de6e7635981.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a large mirror.",
        "public_id": "019e60e1-2118-725a-ae2c-7de6e7635981",
        "storage_key": "property/6737460151192643/019e60e1-2118-725a-ae2c-7de6e7635981.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this beautifully appointed bathroom, featuring a spacious bathtub, modern vanity, and ample storage. Perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eeff0ee0-6c40-4edc-9c64-5c15d4c9b783",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-17e1-70d3-b5e9-444d350f6edb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
        "public_id": "019e60e1-17e1-70d3-b5e9-444d350f6edb",
        "storage_key": "property/6737460151192643/019e60e1-17e1-70d3-b5e9-444d350f6edb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and updated kitchen featuring stainless steel appliances, ample white cabinetry, and elegant marble countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a24fe99-2e6d-4173-bb4c-bb7a516cd83d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-1364-758a-a82a-3fb595408912.webp",
      "image_media": {
        "alt_text": "Living room with beige sofa, blue armchair, coffee table, and peacock artwork.",
        "public_id": "019e60e1-1364-758a-a82a-3fb595408912",
        "storage_key": "property/6737460151192643/019e60e1-1364-758a-a82a-3fb595408912.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and well-lit living room featuring comfortable seating, a stylish coffee table, and elegant decor, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with beige sofa, blue armchair, coffee table, and peacock artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_093b356a-9d7b-437f-bca0-f6e5f309d1d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-15d4-71f9-bbd9-5513ebb02b8e.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment living room and kitchen area with wood-look flooring and stainless steel appliances.",
        "public_id": "019e60e1-15d4-71f9-bbd9-5513ebb02b8e",
        "storage_key": "property/6737460151192643/019e60e1-15d4-71f9-bbd9-5513ebb02b8e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area with a modern kitchen featuring stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Interior view of a modern apartment living room and kitchen area with wood-look flooring and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8cb59cb-c5c3-4084-b1d2-770ceda37f72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-0ddc-738c-a1e2-ba9c5943c13b.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019e60e1-0ddc-738c-a1e2-ba9c5943c13b",
        "storage_key": "property/6737460151192643/019e60e1-0ddc-738c-a1e2-ba9c5943c13b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, ample storage with a dresser and nightstand, and a large window with natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_377135f7-a349-4a62-95d0-a458b32638ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e1-0dd0-7219-9806-1e4cc87f196f.webp",
      "image_media": {
        "alt_text": "Washer and dryer unit in laundry room",
        "public_id": "019e60e1-0dd0-7219-9806-1e4cc87f196f",
        "storage_key": "property/6737460151192643/019e60e1-0dd0-7219-9806-1e4cc87f196f.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry days.",
      "link": "",
      "alt_text": "Washer and dryer unit in laundry room",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a1a3756a-e6ed-4388-bcc4-4ca566faae30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-fe71-75be-8711-44d16bbee221.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with lake and clubhouse.",
        "public_id": "019e60e0-fe71-75be-8711-44d16bbee221",
        "storage_key": "property/6737460151192643/019e60e0-fe71-75be-8711-44d16bbee221.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious apartment community featuring a serene lake and a charming clubhouse, surrounded by lush greenery and mature trees.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with lake and clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f9051b7-9163-40fb-9666-9da1d3ed2e68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-fa2f-75ef-a9ce-937a8c224f4f.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by lush green trees and landscaping.",
        "public_id": "019e60e0-fa2f-75ef-a9ce-937a8c224f4f",
        "storage_key": "property/6737460151192643/019e60e0-fa2f-75ef-a9ce-937a8c224f4f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover apartment living surrounded by nature. Our community offers beautiful exteriors nestled within mature trees.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounded by lush green trees and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f7d67f3-6f95-45c6-b942-f760a15f01e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-fd03-7092-aba7-a0a3e85c3066.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
        "public_id": "019e60e0-fd03-7092-aba7-a0a3e85c3066",
        "storage_key": "property/6737460151192643/019e60e0-fd03-7092-aba7-a0a3e85c3066.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this sleek, modern kitchen featuring stainless steel appliances, granite countertops, and plenty of cabinet storage.",
      "link": "",
      "alt_text": "Modern white kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6ba78ba9-cd5e-4b11-a6b9-892d2fe48a9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-f6c2-727b-8eea-330a3fd9e46a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding a pond with a swimming pool and parking lot.",
        "public_id": "019e60e0-f6c2-727b-8eea-330a3fd9e46a",
        "storage_key": "property/6737460151192643/019e60e0-f6c2-727b-8eea-330a3fd9e46a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Serene apartment community featuring a tranquil pond, a sparkling swimming pool, and convenient parking, surrounded by lush greenery.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounding a pond with a swimming pool and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13c2ab6e-331a-4dc6-9a45-9e9d97a61e6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-f475-768f-8931-f7063fd08798.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a clubhouse surrounded by trees.",
        "public_id": "019e60e0-f475-768f-8931-f7063fd08798",
        "storage_key": "property/6737460151192643/019e60e0-f475-768f-8931-f7063fd08798.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover our apartment community, featuring beautifully maintained buildings and lush green surroundings. Enjoy the serene atmosphere and convenient amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and a clubhouse surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_46a1e90d-f970-4c0f-91c5-e336e60198cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-edcd-707c-87d6-45b78a185d3d.webp",
      "image_media": {
        "alt_text": "Parking lot and apartment buildings exterior view on a sunny day.",
        "public_id": "019e60e0-edcd-707c-87d6-45b78a185d3d",
        "storage_key": "property/6737460151192643/019e60e0-edcd-707c-87d6-45b78a185d3d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Ample parking available for residents and guests in this community, with spacious apartment buildings set against a backdrop of lush greenery.",
      "link": "",
      "alt_text": "Parking lot and apartment buildings exterior view on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c07bbd0c-fd3c-4692-ac0c-0afb9b50efa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-f4ef-739f-9dd9-84ef7e1a1e85.webp",
      "image_media": {
        "alt_text": "Bedroom with sliding glass door to patio and walk-in closet",
        "public_id": "019e60e0-f4ef-739f-9dd9-84ef7e1a1e85",
        "storage_key": "property/6737460151192643/019e60e0-f4ef-739f-9dd9-84ef7e1a1e85.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, large sliding glass doors with patio access, and a walk-in closet for ample storage. Carpeted floors throughout.",
      "link": "",
      "alt_text": "Bedroom with sliding glass door to patio and walk-in closet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b4d18aed-9028-4424-adc8-212d973810cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-edd6-704f-8c3d-c2a28ad5c649.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a marble-look countertop.",
        "public_id": "019e60e0-edd6-704f-8c3d-c2a28ad5c649",
        "storage_key": "property/6737460151192643/019e60e0-edd6-704f-8c3d-c2a28ad5c649.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a clean and bright bathroom featuring a pristine white bathtub and shower, a modern vanity, and a stylish marble-look countertop.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a marble-look countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4912d453-4107-40d5-b22f-ecce782407f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-e67e-7023-bb98-96790cd5adf7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a large mirror.",
        "public_id": "019e60e0-e67e-7023-bb98-96790cd5adf7",
        "storage_key": "property/6737460151192643/019e60e0-e67e-7023-bb98-96790cd5adf7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic bathroom featuring a white bathtub, toilet, and vanity with a marble countertop. A large mirror reflects the space and a glimpse of the bedroom beyond.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dad430a4-3bb6-49a7-9f61-402976f50f1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e60e0-d5e7-76cd-9b8a-9bba1b99f253.webp",
      "image_media": {
        "alt_text": "A beautifully decorated bedroom with a queen-size bed and a desk.",
        "public_id": "019e60e0-d5e7-76cd-9b8a-9bba1b99f253",
        "storage_key": "property/6737460151192643/019e60e0-d5e7-76cd-9b8a-9bba1b99f253.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully decorated bedroom. Features a queen-size bed, a functional desk space, and a ceiling fan for optimal comfort.",
      "link": "",
      "alt_text": "A beautifully decorated bedroom with a queen-size bed and a desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9c22b3b-1108-473d-9d5d-04dcc93e3c09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019fb36f-d2ed-72dd-85c3-40258fbd8de0.webp",
      "image_media": {
        "alt_text": "Fitness center with cable machine, dumbbell rack, and weight balls.",
        "public_id": "019fb36f-d2ed-72dd-85c3-40258fbd8de0",
        "storage_key": "property/6737460151192643/019fb36f-d2ed-72dd-85c3-40258fbd8de0.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of equipment, including a cable machine, a dumbbell rack, and medicine balls, to help you achieve your fitness goals.",
      "link": "",
      "alt_text": "Fitness center with cable machine, dumbbell rack, and weight balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a334acc6-6fc2-4e41-a03a-83dc2499f70e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019fb36f-d1ce-7642-b49e-a5afff3d02db.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by lush trees and apartment buildings.",
        "public_id": "019fb36f-d1ce-7642-b49e-a5afff3d02db",
        "storage_key": "property/6737460151192643/019fb36f-d1ce-7642-b49e-a5afff3d02db.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, complete with comfortable lounge chairs and shaded areas for relaxation. Perfect for sunny days!",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas, surrounded by lush trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b920d79-006a-4503-ade7-73cf1cc01c14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019fb36f-d20b-752d-b25a-09aefbd10630.webp",
      "image_media": {
        "alt_text": "Community business center with computers, printer, and coffee maker.",
        "public_id": "019fb36f-d20b-752d-b25a-09aefbd10630",
        "storage_key": "property/6737460151192643/019fb36f-d20b-752d-b25a-09aefbd10630.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay connected in our community business center, equipped with computers, a printer, and complimentary coffee.",
      "link": "",
      "alt_text": "Community business center with computers, printer, and coffee maker.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2474e88b-700a-4708-be0e-0f16793ead5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-4238-741d-8787-3f62b9b876ac.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by trees with a small lake.",
        "public_id": "019e1ddb-4238-741d-8787-3f62b9b876ac",
        "storage_key": "property/6737460151192643/019e1ddb-4238-741d-8787-3f62b9b876ac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience serene living in this apartment community, nestled amidst lush greenery with a tranquil lake.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounded by trees with a small lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a0b38ee-40b5-46b4-b13f-8a9de7a1574a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-42fc-716b-b6b5-44d3d58510d0.webp",
      "image_media": {
        "alt_text": "Aerial view of a large apartment complex with a lake and clubhouse.",
        "public_id": "019e1ddb-42fc-716b-b6b5-44d3d58510d0",
        "storage_key": "property/6737460151192643/019e1ddb-42fc-716b-b6b5-44d3d58510d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover your new home at this beautiful apartment community, featuring lush greenery, a serene lake, and a spacious clubhouse for residents.",
      "link": "",
      "alt_text": "Aerial view of a large apartment complex with a lake and clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_20258ffe-0daa-4fc9-893e-fb845e571452",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "The Bistreaux by Fleur de Licious",
      "poi_type": "Restaurants",
      "poi_address": "2700 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-fd79-703c-af08-827a7d5f5f28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddb-fd79-703c-af08-827a7d5f5f28",
        "storage_key": "property/6737460151192643/019e1ddb-fd79-703c-af08-827a7d5f5f28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14283013444938582719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bistreaux-by-fleur-de-licious",
      "poi_latitude": "34.0456158",
      "poi_longitude": "-81.0999799",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-205-1785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5zX3b7ej-IgRv0qxsw11N8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d6b9d881-cf09-48ca-bc37-51439df1ec27",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Rush's",
      "poi_type": "Restaurants",
      "poi_address": "2640 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Local fast-food chain serving burgers, hot dogs & fried chicken, plus shakes & ice cream.",
      "poi_long_description": "Local fast-food chain serving burgers, hot dogs & fried chicken, plus shakes & ice cream.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-0162-76f0-a920-dfb8fc6bc23d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-0162-76f0-a920-dfb8fc6bc23d",
        "storage_key": "property/6737460151192643/019e1ddc-0162-76f0-a920-dfb8fc6bc23d.webp",
        "width": 1280,
        "height": 788
      },
      "poi_business_url": "http://www.rushs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9468280930453700653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rushs",
      "poi_latitude": "34.0447461",
      "poi_longitude": "-81.0994446",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-772-2393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRw2V5Ayj-IgRLUBMVVcXZoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_761ef043-e12a-4687-842c-84813aceba06",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Pon Di River Caribbean Bar and Bistro",
      "poi_type": "Restaurants",
      "poi_address": "2344 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-047f-736d-b9b8-89ab54a10b9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-047f-736d-b9b8-89ab54a10b9f",
        "storage_key": "property/6737460151192643/019e1ddc-047f-736d-b9b8-89ab54a10b9f.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10779592792099366836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pon-di-river-caribbean-bar-and-bistro",
      "poi_latitude": "34.0414813",
      "poi_longitude": "-81.0957507",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-638-4220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP85ukeej-IgRtKdxHIjOmJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_963bd441-1e1e-47d3-9190-8102ad08511e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Lizard's Thicket Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1824 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Family-owned chain serving fried chicken & other Southern favorites in a low-key setting.",
      "poi_long_description": "Family-owned chain serving fried chicken & other Southern favorites in a low-key setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-04b8-767c-8f20-274b2cbb30a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-04b8-767c-8f20-274b2cbb30a0",
        "storage_key": "property/6737460151192643/019e1ddc-04b8-767c-8f20-274b2cbb30a0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lizardsthicket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14950097171645586110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lizards-thicket-restaurant",
      "poi_latitude": "34.0361733",
      "poi_longitude": "-81.0891652",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 803-798-6427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSvcP2-j-IgRvtqBKStqec8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_84fde637-20de-475f-ad26-3e10469935cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "2208 Bush River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-fd8f-71fe-b1cb-ac7580f5e9c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddb-fd8f-71fe-b1cb-ac7580f5e9c9",
        "storage_key": "property/6737460151192643/019e1ddb-fd8f-71fe-b1cb-ac7580f5e9c9.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/sc/columbia/42/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=9486437041386145139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "34.0318549",
      "poi_longitude": "-81.1234848",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-731-0672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHXkTJN6i-IgRc8XtUzqYpoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f7f15d76-f0c3-410a-9d51-1356d8c45d44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Columbo's",
      "poi_type": "Restaurants",
      "poi_address": "2100 Bush River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Casual bar & eatery in the DoubleTree hotel featuring American dishes with a Southern flair.",
      "poi_long_description": "Casual bar & eatery in the DoubleTree hotel featuring American dishes with a Southern flair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-04c2-7205-834f-72f2b49a18e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-04c2-7205-834f-72f2b49a18e3",
        "storage_key": "property/6737460151192643/019e1ddc-04c2-7205-834f-72f2b49a18e3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.columbos.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3937814121638598401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbos",
      "poi_latitude": "34.0316667",
      "poi_longitude": "-81.1188889",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-744-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt7ey9R-j-IgRARfJhxTtpTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e7345a5d-183b-4ff0-a732-babc63320c0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Tokyo Grill",
      "poi_type": "Restaurants",
      "poi_address": "1316 Bush River Rd e1, Columbia, SC 29210, USA",
      "poi_short_description": "Counter-serve restaurant chain with hibachi & teriyaki meats, plus sushi, salads & Japanese sides.",
      "poi_long_description": "Counter-serve restaurant chain with hibachi & teriyaki meats, plus sushi, salads & Japanese sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-03b1-73f8-967c-6e01deac1ac7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-03b1-73f8-967c-6e01deac1ac7",
        "storage_key": "property/6737460151192643/019e1ddc-03b1-73f8-967c-6e01deac1ac7.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.tokyogrill.com/locations/tokyo-grill-columbia-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=16488111845174105943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tokyo-grill",
      "poi_latitude": "34.0301186",
      "poi_longitude": "-81.1069006",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-772-0988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkca-aj2j-IgRV1eDjF2K0eQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_3337b4b2-5563-4cd1-b9b2-86b1b6df007a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Skeet and Ro’s Seasoned with Soul",
      "poi_type": "Restaurants",
      "poi_address": "3106 Broad River Rd suite 10, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-00da-71dd-90af-464c42153f6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-00da-71dd-90af-464c42153f6d",
        "storage_key": "property/6737460151192643/019e1ddc-00da-71dd-90af-464c42153f6d.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://skeetandros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=648607403364034663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skeet-and-ros-seasoned-with-soul",
      "poi_latitude": "34.0511902",
      "poi_longitude": "-81.1055142",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-960-7781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bRG31uj-IgRZ6gzNP9QAAk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_10520c30-7da5-4514-b3b1-1f09b7a31453",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Real Mexico Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2421 Bush River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Snug Mexican outlet with a few outdoor tables serving traditional eats & margaritas in unfussy digs.",
      "poi_long_description": "Snug Mexican outlet with a few outdoor tables serving traditional eats & margaritas in unfussy digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-fd85-75be-8d1a-f179ec478dbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddb-fd85-75be-8d1a-f179ec478dbd",
        "storage_key": "property/6737460151192643/019e1ddb-fd85-75be-8d1a-f179ec478dbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://realmexicorestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5677171773887387715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "real-mexico-restaurant",
      "poi_latitude": "34.0338394",
      "poi_longitude": "-81.1252259",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-750-8990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt3m8Suei-IgRQ5huP6ZdyU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3ce13b93-e487-4cb8-b68a-2601bb419ef3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Bojangles",
      "poi_type": "Restaurants",
      "poi_address": "2423 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Southern-inspired fast-food chain known for fried chicken & biscuit, plus signature sides.",
      "poi_long_description": "Southern-inspired fast-food chain known for fried chicken & biscuit, plus signature sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-0915-74d2-acdb-4fd04f624c24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-0915-74d2-acdb-4fd04f624c24",
        "storage_key": "property/6737460151192643/019e1ddc-0915-74d2-acdb-4fd04f624c24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.bojangles.com/sc/columbia/2423-broad-river-road-392.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4640711200643409950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bojangles",
      "poi_latitude": "34.042264",
      "poi_longitude": "-81.09793599999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-731-4977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_eTaTw2j-IgRHuiG2z8eZ0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3f2c6c0a-d08f-46eb-9a2d-217b818644e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "3036 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-09c0-7341-a8cb-af2ba08c7670.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-09c0-7341-a8cb-af2ba08c7670",
        "storage_key": "property/6737460151192643/019e1ddc-09c0-7341-a8cb-af2ba08c7670.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/sc/columbia/3036-broad-river-road/store-1854?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg0NzY0NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2313210720070243429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "34.049556",
      "poi_longitude": "-81.1047483",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-750-7530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQH3EAmj-IgRZZRp3OQsGiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e651ddb7-87a2-4bfe-9524-69e8d57a87c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "The Peanut Man",
      "poi_type": "Restaurants",
      "poi_address": "3905 Fernandina Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Gourmet cafe offering hot meals, sandwiches, salads, and desserts, plus a gift shop and robot servers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-0a4d-704c-8a60-1212f9a179ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-0a4d-704c-8a60-1212f9a179ce",
        "storage_key": "property/6737460151192643/019e1ddc-0a4d-704c-8a60-1212f9a179ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thepeanutman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3681190218107936827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-peanut-man",
      "poi_latitude": "34.0661058",
      "poi_longitude": "-81.1396918",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-724-2118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwyzfmJqj-IgRO2D35P82FjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8836b97c-fc0d-433b-9ef1-5380db5f97a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Asian Express",
      "poi_type": "Restaurants",
      "poi_address": "1935 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Relaxed eatery serving comfort food, fried dishes and seafood boils, plus hibachi and fried rice.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-0e24-7289-8948-249219abaeaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-0e24-7289-8948-249219abaeaf",
        "storage_key": "property/6737460151192643/019e1ddc-0e24-7289-8948-249219abaeaf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.asianexpresssc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6940538175365875906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asian-express",
      "poi_latitude": "34.0366828",
      "poi_longitude": "-81.0907273",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-391-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34TDUoKj-IgRwoi4rLK-UWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_64ee634b-9031-4ef7-916f-8d5bbe4c34d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "China Hut Ace",
      "poi_type": "Restaurants",
      "poi_address": "724 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Casual Chinese restaurant popular for its wings, along with lunch and dinner plates, plus sweet tea.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-0b5d-70a9-b2f9-26ec9c1b131f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-0b5d-70a9-b2f9-26ec9c1b131f",
        "storage_key": "property/6737460151192643/019e1ddc-0b5d-70a9-b2f9-26ec9c1b131f.webp",
        "width": 1280,
        "height": 922
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2339926625794524800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-hut-ace",
      "poi_latitude": "34.0250562",
      "poi_longitude": "-81.0776293",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 803-750-6454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSmdIl-j-IgRgAb2Yt4WeSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_c318b507-0d71-4b4a-8657-5ea0d838e024",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "American Deli",
      "poi_type": "Restaurants",
      "poi_address": "2700 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Informal counter-serve chain offering hot wings, cheesesteaks & other comfort foods.",
      "poi_long_description": "Informal counter-serve chain offering hot wings, cheesesteaks & other comfort foods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-0e26-70e3-a4d3-dfb9253e45ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-0e26-70e3-a4d3-dfb9253e45ae",
        "storage_key": "property/6737460151192643/019e1ddc-0e26-70e3-a4d3-dfb9253e45ae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://americandeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10089528709912631555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-deli",
      "poi_latitude": "34.0456158",
      "poi_longitude": "-81.0999799",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-834-3064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5385-764d-afdd-3a507093ece1",
        "storage_key": "property/6737460151192643/019e1ddb-5385-764d-afdd-3a507093ece1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZe5mQSj-IgRA5lysec0BYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5e3249be-ddcb-4ee3-a696-63a5fe9aca88",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "1013 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Grocery featuring fresh produce, plus an in-store bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-11b2-770f-be60-5618c5e23dcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-11b2-770f-be60-5618c5e23dcd",
        "storage_key": "property/6737460151192643/019e1ddc-11b2-770f-be60-5618c5e23dcd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/sc/columbia/1013-broad-river-road?y_source=1_NTA0NjU5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7939388014312032269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "34.0245875",
      "poi_longitude": "-81.08122589999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 803-798-2435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5308-749b-89d1-6ebde04ffe50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5308-749b-89d1-6ebde04ffe50",
        "storage_key": "property/6737460151192643/019e1ddb-5308-749b-89d1-6ebde04ffe50.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUfh3nV6j-IgRDQgQl1VfLm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_783a923a-e8c4-4f40-8b2d-8f01e76facb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "1563B Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-0ef3-76e6-9d27-87675cfbfcee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-0ef3-76e6-9d27-87675cfbfcee",
        "storage_key": "property/6737460151192643/019e1ddc-0ef3-76e6-9d27-87675cfbfcee.webp",
        "width": 427,
        "height": 640
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/sc/columbia/10749",
      "poi_directions_map_url": "https://maps.google.com/?cid=13052675741229001464&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "34.0314001",
      "poi_longitude": "-81.09038389999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-567-1070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUS1UYWij-IgR-CpQPG5rJLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_93d1f0a9-18a3-4643-9795-4ac822451b14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "2505 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-113c-74af-9812-8ef23efa9eff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-113c-74af-9812-8ef23efa9eff",
        "storage_key": "property/6737460151192643/019e1ddc-113c-74af-9812-8ef23efa9eff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.familydollar.com/sc/columbia/2505-broad-river-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12183946985615322970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "34.0431229",
      "poi_longitude": "-81.0991913",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-728-2494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjWZmFA2j-IgRWu_K5zoTFqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_e0eb9c30-5a78-4460-a297-307fd36a264b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "3004 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-159b-7398-8393-bbc19f8d5804.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-159b-7398-8393-bbc19f8d5804",
        "storage_key": "property/6737460151192643/019e1ddc-159b-7398-8393-bbc19f8d5804.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/columbia/3004-broad-river-rd/2705361?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16654242665309179215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "34.0490245",
      "poi_longitude": "-81.10422109999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-731-4986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55d0-75c8-ae39-20fe68b2a37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55d0-75c8-ae39-20fe68b2a37e",
        "storage_key": "property/6737460151192643/019e1ddc-55d0-75c8-ae39-20fe68b2a37e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJBVbNawmj-IgRT43oVHfBH-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_92053820-038a-4f13-8cdf-ff87f0f3e127",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "King's Beverage",
      "poi_type": "Shopping & Retail",
      "poi_address": "2719 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Liquor store also selling food, this quick-visit establishment draws positive remarks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-1616-7338-a2ba-449212f146a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-1616-7338-a2ba-449212f146a2",
        "storage_key": "property/6737460151192643/019e1ddc-1616-7338-a2ba-449212f146a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5358051131433975023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-beverage",
      "poi_latitude": "34.04522900000001",
      "poi_longitude": "-81.1009902",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-798-1331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ54_QWgyj-IgR73yAqR2fW0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "custom_188fdd06-be71-42f6-8362-1673839ba9a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "7338 Broad River Rd, Irmo, SC 29063, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.dollartree.com/sc/irmo/7338-broad-river-road",
      "poi_directions_map_url": "https://maps.google.com/?cid=16511866427494073957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "34.0968631",
      "poi_longitude": "-81.1596423",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 803-470-4727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZZQnBQCj-IgRZYZ7PQjvJeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_b5cd2b25-4b12-4b02-b7f3-2720900b0c36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Dutch Square Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "421 Bush River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Modest, old-school retail complex with a mix of large chains & small specialty shops, plus a cinema.",
      "poi_long_description": "Modest, old-school retail complex with a mix of large chains & small specialty shops, plus a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-1602-75bc-80dc-5452c16abba2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-1602-75bc-80dc-5452c16abba2",
        "storage_key": "property/6737460151192643/019e1ddc-1602-75bc-80dc-5452c16abba2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dutchsquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17613709281298278904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-square-center",
      "poi_latitude": "34.0328281",
      "poi_longitude": "-81.0921907",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-772-3864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqyNH0muj-IgR-OnIGEV3cPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_632c0314-c3cb-493b-9d3b-a4b0f9c91e3e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "302 Bush River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Discount retailer selling clothing, accessories, shoes and household items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-139b-76f8-86a0-85da0d5cac53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-139b-76f8-86a0-85da0d5cac53",
        "storage_key": "property/6737460151192643/019e1ddc-139b-76f8-86a0-85da0d5cac53.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/sc/columbia/128/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6248060316156979128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "34.0319815",
      "poi_longitude": "-81.0916117",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-798-5990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz9yK5mmj-IgRuGfA_8CRtVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e565fab9-36af-4666-86b1-95f57e798b1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Hibbett",
      "poi_type": "Shopping & Retail",
      "poi_address": "421 Bush River Rd Unit 176, Columbia, SC 29210, USA",
      "poi_short_description": "Retail chain selling athletic shoes, apparel & accessories, plus licensed team merchandise.",
      "poi_long_description": "Retail chain selling athletic shoes, apparel & accessories, plus licensed team merchandise.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-1e25-76f8-8fba-dea7509bb6c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-1e25-76f8-8fba-dea7509bb6c5",
        "storage_key": "property/6737460151192643/019e1ddc-1e25-76f8-8fba-dea7509bb6c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hibbett.com/storedetails/SC/Columbia/512?utm_source=gmblisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16925026260096400953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hibbett",
      "poi_latitude": "34.0334413",
      "poi_longitude": "-81.0919346",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-772-8566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLXfVKmqj-IgROT40_7XF4eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_9779511f-5789-448a-bfad-ff05ab673147",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "H.B. Rhame Elementary School",
      "poi_type": "Education",
      "poi_address": "1300 Arrowwood Rd, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rhame.richlandone.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14571580161127575728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hb-rhame-elementary-school",
      "poi_latitude": "34.0261616",
      "poi_longitude": "-81.0871945",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 803-731-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJicv-qF2j-IgRsHAj-POmOMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d469783f-fd81-4ca4-b78c-f5fa74f5baae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "St. Andrews Middle School",
      "poi_type": "Education",
      "poi_address": "1231 Bluefield Dr, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://sams.richlandone.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2870057823886361506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-andrews-middle-school",
      "poi_latitude": "34.0273826",
      "poi_longitude": "-81.0878208",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-731-8910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ05LK0Oj-IgRosOTdWJ-1Cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_25ef0001-c7ca-4611-8dcf-0e7c4297787e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Columbia High School",
      "poi_type": "Education",
      "poi_address": "1701 Westchester Dr, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.richlandone.org/Domain/46",
      "poi_directions_map_url": "https://maps.google.com/?cid=7720982450788224691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-high-school",
      "poi_latitude": "34.0496804",
      "poi_longitude": "-81.0915727",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-731-8950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4aos1nWj-IgRs85BqKFwJms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_65837564-2203-409f-b589-92077252fe25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Pinegrove Elementary School",
      "poi_type": "Education",
      "poi_address": "111 Huffstetler Dr, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.richlandone.org/pinegrove",
      "poi_directions_map_url": "https://maps.google.com/?cid=11958241300105045973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinegrove-elementary-school",
      "poi_latitude": "34.0584718",
      "poi_longitude": "-81.11661660000001",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-214-2380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJafemU6mj-IgR1acq3xo19KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3b744abf-e759-4002-b3c4-5afa987e0a32",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Sunshine House of Columbia at Broad River Road",
      "poi_type": "Education",
      "poi_address": "3011 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Daycare center providing early education for children from 6 weeks to 12 years old.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-1c27-742c-ace6-343bca6661a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-1c27-742c-ace6-343bca6661a2",
        "storage_key": "property/6737460151192643/019e1ddc-1c27-742c-ace6-343bca6661a2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://sunshinehouse.com/broad-river/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9900347955749352189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunshine-house-of-columbia-at-broad-river-road",
      "poi_latitude": "34.0490432",
      "poi_longitude": "-81.10563859999999",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-772-0517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWwn-Hwmj-IgR_XI07wIaZYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_27273d07-14ea-416b-b080-3bbede5bc5fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Westminster Child Development",
      "poi_type": "Education",
      "poi_address": "1715 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9254541205858551900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westminster-child-development",
      "poi_latitude": "34.0337518",
      "poi_longitude": "-81.08941140000002",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-798-4590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB_rOH2mj-IgRXAhqrjG8boA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_8ba2fd4d-b82f-4c07-860d-e76ee4eb4a83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Legacy Learners Academy",
      "poi_type": "Education",
      "poi_address": "1342 Omarest Dr, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-1cb5-7758-ad1b-51367b234db7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-1cb5-7758-ad1b-51367b234db7",
        "storage_key": "property/6737460151192643/019e1ddc-1cb5-7758-ad1b-51367b234db7.webp",
        "width": 1280,
        "height": 605
      },
      "poi_business_url": "http://mylegacylearners.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4638937806517857319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legacy-learners-academy",
      "poi_latitude": "34.033808",
      "poi_longitude": "-81.0863957",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 803-973-0356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4WrHuMyj-IgRJ2ygXFvRYEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_0d20570f-41ab-4827-aac7-171ebe3a287a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Midlands Technical College - Beltline Campus",
      "poi_type": "Education",
      "poi_address": "316 S Beltline Blvd, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2141-750f-bd70-9563f8c0147b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2141-750f-bd70-9563f8c0147b",
        "storage_key": "property/6737460151192643/019e1ddc-2141-750f-bd70-9563f8c0147b.webp",
        "width": 1280,
        "height": 753
      },
      "poi_business_url": "https://www.midlandstech.edu/?utm_source=google&utm_medium=organic&utm_campaign=gbp_beltline_campus&utm_content=profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=10653580075159774172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midlands-technical-college---beltline-campus",
      "poi_latitude": "33.988198",
      "poi_longitude": "-80.9804606",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 803-738-8324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ68VGWg-w-IgR3OMTHqIe2ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5da60fca-c35e-4ce5-b55e-e3b80163a7b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "University of South Carolina",
      "poi_type": "Education",
      "poi_address": "1501 Pendleton St, Columbia, SC 29208, USA",
      "poi_short_description": "Founded in 1801, this school features historic buildings & museums on its 218-acre campus.",
      "poi_long_description": "Founded in 1801, this school features historic buildings & museums on its 218-acre campus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-19d5-73de-9930-21e3b8a57a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-19d5-73de-9930-21e3b8a57a3a",
        "storage_key": "property/6737460151192643/019e1dda-19d5-73de-9930-21e3b8a57a3a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8700236860325688654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-south-carolina",
      "poi_latitude": "33.99488420000001",
      "poi_longitude": "-81.028503",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-777-0169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6ayLCi7-IgRTvV4IVRzvXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c6787e0c-7fe8-459f-9027-f05306424e4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Benedict College",
      "poi_type": "Education",
      "poi_address": "1600 Harden St, Columbia, SC 29204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-21a0-77a1-9233-e8b71b2251ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-21a0-77a1-9233-e8b71b2251ec",
        "storage_key": "property/6737460151192643/019e1dda-21a0-77a1-9233-e8b71b2251ec.webp",
        "width": 1280,
        "height": 966
      },
      "poi_business_url": "http://www.benedict.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=980414326126798695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benedict-college",
      "poi_latitude": "34.01302",
      "poi_longitude": "-81.0195629",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB0EqCDCl-IgRZ-d9maIhmw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_286a83c3-2d85-4e45-bb83-90d86f89f11b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "EdVenture Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "211 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "Over 350 hands-on exhibits that allow kids to explore human biology, nature, inventions & careers.",
      "poi_long_description": "Over 350 hands-on exhibits that allow kids to explore human biology, nature, inventions & careers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-45b9-7579-9c59-967d7f79e465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddb-45b9-7579-9c59-967d7f79e465",
        "storage_key": "property/6737460151192643/019e1ddb-45b9-7579-9c59-967d7f79e465.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://edventure.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5009014924889452888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edventure",
      "poi_latitude": "33.9971663",
      "poi_longitude": "-81.0481712",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "140",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-779-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b5-744e-8306-c281c75c7e21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b5-744e-8306-c281c75c7e21",
        "storage_key": "property/6737460151192643/019e1ddb-52b5-744e-8306-c281c75c7e21.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExeBHze7-IgRWHGqCImYg0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_82c975a9-060e-4d98-bb15-ff14e2fa9adf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Columbia Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1515 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Paintings & sculptures spanning thousands of years, displayed in a contemporary building.",
      "poi_long_description": "Paintings & sculptures spanning thousands of years, displayed in a contemporary building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2997-74cb-873f-76a8503000c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2997-74cb-873f-76a8503000c9",
        "storage_key": "property/6737460151192643/019e1ddc-2997-74cb-873f-76a8503000c9.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://www.columbiamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17573773874273889936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-museum-of-art",
      "poi_latitude": "34.0058172",
      "poi_longitude": "-81.0362938",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-799-2810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b5-744e-8306-c281c75c7e21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b5-744e-8306-c281c75c7e21",
        "storage_key": "property/6737460151192643/019e1ddb-52b5-744e-8306-c281c75c7e21.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJca7xktSk-IgRkK4ikzqW4vM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_34b9ae0d-9c6c-4eb5-bfa9-03acc08f3b49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "South Carolina Museum",
      "poi_type": "Entertainment",
      "poi_address": "301 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "Exhibits on art, history, nature, science & technology, housed on 4 floors in a former textile mill.",
      "poi_long_description": "Exhibits on art, history, nature, science & technology, housed on 4 floors in a former textile mill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-2ed8-7381-9083-67c5056f38a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-2ed8-7381-9083-67c5056f38a1",
        "storage_key": "property/6737460151192643/019e1dda-2ed8-7381-9083-67c5056f38a1.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://scmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=928196305548677249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-state-museum",
      "poi_latitude": "33.9990559",
      "poi_longitude": "-81.0480824",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "120",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-898-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b5-744e-8306-c281c75c7e21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b5-744e-8306-c281c75c7e21",
        "storage_key": "property/6737460151192643/019e1ddb-52b5-744e-8306-c281c75c7e21.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB7F6NjG7-IgRgRAPQp-d4Qw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fa493d25-b46b-485d-a1c7-6f96bf82ff6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Columbia Marionette Theatre",
      "poi_type": "Entertainment",
      "poi_address": "401 Laurel St, Columbia, SC 29201, USA",
      "poi_short_description": "Theater where puppets perform on a roomy stage also has multiple themed rooms available for parties.",
      "poi_long_description": "Theater where puppets perform on a roomy stage also has multiple themed rooms available for parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-234a-713b-b657-7d503b7e7384.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-234a-713b-b657-7d503b7e7384",
        "storage_key": "property/6737460151192643/019e1ddc-234a-713b-b657-7d503b7e7384.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmtpuppet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7700138818565838747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-marionette-theatre",
      "poi_latitude": "34.0056968",
      "poi_longitude": "-81.0498724",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-252-7366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw071Osuk-IgRmxfQWXVj3Go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_c5988e50-cd7d-4b6e-a64c-d54600324d0d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Nickelodeon Theater",
      "poi_type": "Entertainment",
      "poi_address": "1607 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Patrons sip beer & wine while watching independent & foreign films at this small nonprofit cinema.",
      "poi_long_description": "Patrons sip beer & wine while watching independent & foreign films at this small nonprofit cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-302a-7203-9fe1-ed3eedd4c63d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-302a-7203-9fe1-ed3eedd4c63d",
        "storage_key": "property/6737460151192643/019e1ddc-302a-7203-9fe1-ed3eedd4c63d.webp",
        "width": 1280,
        "height": 652
      },
      "poi_business_url": "https://nickelodeon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10056715905331871030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nickelodeon-theater",
      "poi_latitude": "34.0068542",
      "poi_longitude": "-81.0362645",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-254-8234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55d2-7258-a127-b26da69f4abb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55d2-7258-a127-b26da69f4abb",
        "storage_key": "property/6737460151192643/019e1ddc-55d2-7258-a127-b26da69f4abb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-a_hyS27-IgRNr1TSNWhkIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d84c0e1c-0d67-4eed-8144-0a58f5b2cb57",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Koger Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "1051 Greene St, Columbia, SC 29201, USA",
      "poi_short_description": "Contemporary university-based theater hosting a variety of music, drama & dance performances.",
      "poi_long_description": "Contemporary university-based theater hosting a variety of music, drama & dance performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2355-712d-860a-3b28fc237930.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2355-712d-860a-3b28fc237930",
        "storage_key": "property/6737460151192643/019e1ddc-2355-712d-860a-3b28fc237930.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kogercenterforthearts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12257849216363590786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "koger-center-for-the-arts",
      "poi_latitude": "33.9954349",
      "poi_longitude": "-81.0341062",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-777-5112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXrGTCi7-IgRgvSm2-qgHKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_104a10f5-1dcf-476a-9346-e22044fb3d61",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Township Auditorium",
      "poi_type": "Entertainment",
      "poi_address": "1703 Taylor St, Columbia, SC 29201, USA",
      "poi_short_description": "Performance hall staging concerts and ballet, as well as other events, and welcoming wheelchairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2741-7651-b884-d2d40742d731.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2741-7651-b884-d2d40742d731",
        "storage_key": "property/6737460151192643/019e1ddc-2741-7651-b884-d2d40742d731.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://thetownship.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17024630509826557127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "township-auditorium",
      "poi_latitude": "34.0095228",
      "poi_longitude": "-81.027622",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-576-2350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2a60zO7-IgRx0R9kj-jQ-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auditorium"
    },
    {
      "id": "custom_79a8f294-7dfb-4f36-8b13-b98f7b584f93",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Regal Sandhill",
      "poi_type": "Entertainment",
      "poi_address": "450 Town Center Pl, Columbia, SC 29229, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2a00-7106-a08c-4e6ed9430054.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2a00-7106-a08c-4e6ed9430054",
        "storage_key": "property/6737460151192643/019e1ddc-2a00-7106-a08c-4e6ed9430054.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-sandhill-1855?utm_campaign=gmb-listing&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=4115867517535727719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-sandhill",
      "poi_latitude": "34.131077",
      "poi_longitude": "-80.88024",
      "poi_miles_from_property": "16.5",
      "poi_walking_minutes": "6 hours 14 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55d2-7258-a127-b26da69f4abb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55d2-7258-a127-b26da69f4abb",
        "storage_key": "property/6737460151192643/019e1ddc-55d2-7258-a127-b26da69f4abb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaJokDaq-IgRZzBJTbN_Hjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_826dfe34-49d8-4efb-8bf1-9b9513a65650",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Outlet Pointe Blvd, Columbia, SC 29210, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-28ca-733e-982b-e7e349d2f0ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-28ca-733e-982b-e7e349d2f0ef",
        "storage_key": "property/6737460151192643/019e1ddc-28ca-733e-982b-e7e349d2f0ef.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/columbia-sc-pharmacies/100-outlet-point-blvd-columbia-sc-29210/storeid=4156?WT.mc_id=LS_GOOGLE_FS_4156",
      "poi_directions_map_url": "https://maps.google.com/?cid=2355358250817695502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "34.032596",
      "poi_longitude": "-81.12497840000002",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-772-0403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXTVMquCi-IgRDi_GktnpryA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_b8e45662-c82a-4008-b95f-82d0209388b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "360 Harbison Blvd, Columbia, SC 29212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2b07-7362-b37e-359ae11d5f3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2b07-7362-b37e-359ae11d5f3f",
        "storage_key": "property/6737460151192643/019e1ddc-2b07-7362-b37e-359ae11d5f3f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1164-columbia-sc/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13158548679469780451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "34.0733077",
      "poi_longitude": "-81.1507883",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-732-0617",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55d0-75c8-ae39-1da9f9ca97a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55d0-75c8-ae39-1da9f9ca97a5",
        "storage_key": "property/6737460151192643/019e1ddc-55d0-75c8-ae39-1da9f9ca97a5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8pc9G2i-IgR4017l06OnLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9e5849b8-c468-4db0-b5bf-a244f907d28c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1223 St Andrews Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-354a-7628-b737-4b9ac167cdb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-354a-7628-b737-4b9ac167cdb0",
        "storage_key": "property/6737460151192643/019e1ddc-354a-7628-b737-4b9ac167cdb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1223+saint+andrews+rd-columbia-sc-29210/id=9487",
      "poi_directions_map_url": "https://maps.google.com/?cid=12351095259011717120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.050157",
      "poi_longitude": "-81.1066484",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-731-5120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3f38Aij-IgRAJhn_LLnZ6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_ea0f81b7-e421-4942-ac2c-edb184319e40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "421 Bush River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Clean gym offering a workout area with cardio machines, plus tanning booths and massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-3387-73d8-bfb6-00a9518d7b10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-3387-73d8-bfb6-00a9518d7b10",
        "storage_key": "property/6737460151192643/019e1dda-3387-73d8-bfb6-00a9518d7b10.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/columbia-dutch-square-sc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8524996822619848319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.0324955",
      "poi_longitude": "-81.09422649999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-750-7515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXfVKmqj-IgRf_6WW3HfTnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_00186840-2a20-4d02-85d2-564fe9ae66f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Empire Fitness Co.",
      "poi_type": "Health and Wellness",
      "poi_address": "4350 St Andrews Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Gym offering specialized programs, extensive equipment, group classes, and personal training in a 31,000-sq.-ft. space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2dc2-737b-b3e8-aaed2a07f27c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2dc2-737b-b3e8-aaed2a07f27c",
        "storage_key": "property/6737460151192643/019e1ddc-2dc2-737b-b3e8-aaed2a07f27c.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://www.empirefitnessco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12055422441676844840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "empire-fitness-co",
      "poi_latitude": "34.0487439",
      "poi_longitude": "-81.1506746",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-569-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo0_YD4-i-IgRKK9rndZ2Tac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_b0fd9ada-33ee-467a-8dc9-7e8f36ebde1a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "4605 Forest Dr Suite 4, Columbia, SC 29206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2e40-74be-9b5f-3019fbb5a2c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2e40-74be-9b5f-3019fbb5a2c1",
        "storage_key": "property/6737460151192643/019e1ddc-2e40-74be-9b5f-3019fbb5a2c1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/forestacres/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17829810371467191032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "34.0202648",
      "poi_longitude": "-80.9705031",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 803-973-6848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlS9WVwuv-IgR-KLgAxE2cPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9a04c8c8-b33c-4127-8bf3-c56058794b86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "KORE Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "1311B Rosewood Dr, Columbia, SC 29201, USA",
      "poi_short_description": "Fitness studio specializing in \"functional training\" techniques to help build strength and improve fitness overall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-2fc0-702e-8bb0-98ba38b1ec99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-2fc0-702e-8bb0-98ba38b1ec99",
        "storage_key": "property/6737460151192643/019e1ddc-2fc0-702e-8bb0-98ba38b1ec99.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.korewellness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2870474639135079519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kore-wellness",
      "poi_latitude": "33.982888",
      "poi_longitude": "-81.022696",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 803-771-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1WOFd26-IgRX_xp0nn51Sc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cd1e6c5d-0fdc-4ffb-b9a6-5100431ab441",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Prisma Health Richland Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "5 Richland Medical Park Dr, Columbia, SC 29203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-8331-767a-8301-c078654335ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-8331-767a-8301-c078654335ef",
        "storage_key": "property/6737460151192643/019e1dda-8331-767a-8301-c078654335ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://prismahealth.org/locations/hospitals/richland-hospital?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=12389614705206768817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prisma-health-richland-hospital",
      "poi_latitude": "34.0278595",
      "poi_longitude": "-81.0333775",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-434-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5328-7579-9e72-bd7efd38861b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5328-7579-9e72-bd7efd38861b",
        "storage_key": "property/6737460151192643/019e1ddb-5328-7579-9e72-bd7efd38861b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJNdA-P-Ck-IgRsTTOb-7A8Ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_c053be3b-b068-4dfd-9171-0df59a4f79f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Life Health Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Bush River Rd ste b, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-35a8-76a8-8c41-4d74085c0a39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-35a8-76a8-8c41-4d74085c0a39",
        "storage_key": "property/6737460151192643/019e1ddc-35a8-76a8-8c41-4d74085c0a39.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6789214259883545839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-health-spa",
      "poi_latitude": "34.0335171",
      "poi_longitude": "-81.12486830000002",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-798-7376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAZP7ktyj-IgR7xRgCGYiOF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage"
    },
    {
      "id": "custom_b2e57dc1-1f4e-4eea-a922-53086a0ce862",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Saluda Shoals Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5605 Bush River Rd, Columbia, SC 29212, USA",
      "poi_short_description": "400-acre park featuring a river observation deck, boat launches, picnic shelters & multi-use trails.",
      "poi_long_description": "400-acre park featuring a river observation deck, boat launches, picnic shelters & multi-use trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-229b-7781-9c7f-86bf5f672f5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-229b-7781-9c7f-86bf5f672f5a",
        "storage_key": "property/6737460151192643/019e1ddc-229b-7781-9c7f-86bf5f672f5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.icrc.net/park/saluda-shoals-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9822339226455398410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saluda-shoals-park",
      "poi_latitude": "34.0510931",
      "poi_longitude": "-81.1831108",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 803-772-1228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcBPLMZuWIgRClhCSHz1T4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b0a6b199-5ff9-4b2e-9089-2099d43b6c78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Riverbanks Zoo & Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 Wildlife Pkwy, Columbia, SC 29210, USA",
      "poi_short_description": "Zoo with African & Australian animals, reptile galleries, a bird house, a farm & botanical gardens.",
      "poi_long_description": "Zoo with African & Australian animals, reptile galleries, a bird house, a farm & botanical gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-2788-749e-87d1-e23a07499c52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-2788-749e-87d1-e23a07499c52",
        "storage_key": "property/6737460151192643/019e1dda-2788-749e-87d1-e23a07499c52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.riverbanks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5878382912266439608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverbanks-zoo--garden",
      "poi_latitude": "34.0086627",
      "poi_longitude": "-81.0733959",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-779-8717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryFyj1Wj-IgRuAteGx02lFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_9f4bd719-b302-4c4d-81b5-2e007dc79231",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Saluda Riverwalk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "650 Candi Ln, Columbia, SC 29210, USA",
      "poi_short_description": "Popular public park featuring a 7-mile trail for walking, biking and kayaking, plus picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-3f20-709e-bcee-bdd681e59be7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddb-3f20-709e-bcee-bdd681e59be7",
        "storage_key": "property/6737460151192643/019e1ddb-3f20-709e-bcee-bdd681e59be7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parksandrec.columbiasc.gov/regionalparks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10143068239537940972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saluda-riverwalk",
      "poi_latitude": "34.0135766",
      "poi_longitude": "-81.082009",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-397-6556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0EhNVqj-IgR7Kk01tJqw4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dc64fd4c-3ac5-465d-9d76-94fb9037c731",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Columbia Riverfront Park North",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4122 River Dr, Columbia, SC 29201, USA",
      "poi_short_description": "Spacious tract for picnics, biking, fishing, dog-walking and strolling, with riverside views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-3ac9-7359-8e6e-ec1a0f0b55f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-3ac9-7359-8e6e-ec1a0f0b55f4",
        "storage_key": "property/6737460151192643/019e1ddc-3ac9-7359-8e6e-ec1a0f0b55f4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11474834096334783444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverfront-park-north",
      "poi_latitude": "34.0328078",
      "poi_longitude": "-81.0681883",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-917-5522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ80jcb5mk-IgR1EOTeNDMPp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_84ccc230-1c39-46b3-813a-d4441e17e48d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Columbia Canal and Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "312 Laurel St, Columbia, SC 29201, USA",
      "poi_short_description": "Old pump houses shed light on the canal works amid natural hiking & biking trails & picnic tables.",
      "poi_long_description": "Old pump houses shed light on the canal works amid natural hiking & biking trails & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-a8da-748c-b7c0-e1244c9e6f6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-a8da-748c-b7c0-e1244c9e6f6a",
        "storage_key": "property/6737460151192643/019e1dda-a8da-748c-b7c0-e1244c9e6f6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parksandrec.columbiasc.gov/regionalparks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8911544469547747247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-canal-and-riverfront-park",
      "poi_latitude": "34.0037859",
      "poi_longitude": "-81.05124239999999",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-545-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48T5nLCk-IgRr4d9y3oqrHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a9e89e3f-5dfb-4470-b388-093cec4af6e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Granby Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Catawba Cir, Columbia, SC 29201, USA",
      "poi_short_description": "Natural retreat on the river with hiking, biking & horse trails, disc golf, fishing, camps & cabins.",
      "poi_long_description": "Natural retreat on the river with hiking, biking & horse trails, disc golf, fishing, camps & cabins.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-3a5f-7708-bb09-1b6e82c47c2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-3a5f-7708-bb09-1b6e82c47c2f",
        "storage_key": "property/6737460151192643/019e1ddc-3a5f-7708-bb09-1b6e82c47c2f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parksandrec.columbiasc.gov/regionalparks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12366516078987582956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "granby-park",
      "poi_latitude": "33.9838524",
      "poi_longitude": "-81.0442965",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXCfRD27-IgR7B02bdqwnqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_448938f0-6dcb-4650-aad8-cacf21b5d5ce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Seven Oaks Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 Leisure Ln, Columbia, SC 29210, USA",
      "poi_short_description": "Park with a 30,000-sq.-ft. leisure center with 3 gyms, 9 athletic fields, trails & playgrounds.",
      "poi_long_description": "Park with a 30,000-sq.-ft. leisure center with 3 gyms, 9 athletic fields, trails & playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-b274-756c-99d7-7395793f722d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-b274-756c-99d7-7395793f722d",
        "storage_key": "property/6737460151192643/019e1dda-b274-756c-99d7-7395793f722d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.icrc.net/park/seven-oaks-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5023034650861801484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seven-oaks-park",
      "poi_latitude": "34.0503541",
      "poi_longitude": "-81.1539567",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-772-3336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3XK_4Wi-IgRDJAY22ZntUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_610e66c8-ec58-4f88-9f21-1772e7790897",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "W. Gordon Belser Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4080 Bloomwood Rd, Columbia, SC 29205, USA",
      "poi_short_description": "Arboretum on the University of South Carolina campus featuring labeled trees and plants, and informational plaques.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-3920-77c8-a39a-841fb393d8b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-3920-77c8-a39a-841fb393d8b7",
        "storage_key": "property/6737460151192643/019e1ddc-3920-77c8-a39a-841fb393d8b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sc.edu/study/colleges_schools/artsandsciences/biological_sciences/research/resources_facilities/arboretum/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=1183359631989017830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-gordon-belser-arboretum",
      "poi_latitude": "33.994078",
      "poi_longitude": "-80.9844517",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 803-563-8118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn326Hgew-IgR5gw-ylAjbBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_d5a657b4-0d94-49b5-883d-d220840a46a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Sesquicentennial State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9564 Two Notch Rd, Columbia, SC 29223, USA",
      "poi_short_description": "Forested park with a lake offering campsites, kayak & canoe rentals, a bicycle loop & nature trails.",
      "poi_long_description": "Forested park with a lake offering campsites, kayak & canoe rentals, a bicycle loop & nature trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-3e2f-770a-99b0-d33fe8e30acb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-3e2f-770a-99b0-d33fe8e30acb",
        "storage_key": "property/6737460151192643/019e1ddc-3e2f-770a-99b0-d33fe8e30acb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://southcarolinaparks.com/sesqui",
      "poi_directions_map_url": "https://maps.google.com/?cid=15568892834672260028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sesquicentennial-state-park",
      "poi_latitude": "34.0869602",
      "poi_longitude": "-80.90633679999999",
      "poi_miles_from_property": "12.8",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 803-788-2706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2VkvhFGp-IgRvLPDrIvRD9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_80c957b4-ceaf-4314-b304-3e9775371184",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "540 smoke & vape",
      "poi_type": "Transportation & Transit",
      "poi_address": "1530 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-3f04-73dc-8984-1d8f02b8cd93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-3f04-73dc-8984-1d8f02b8cd93",
        "storage_key": "property/6737460151192643/019e1ddc-3f04-73dc-8984-1d8f02b8cd93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11555399754438169062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "540-smoke--vape",
      "poi_latitude": "34.0327333",
      "poi_longitude": "-81.0875666",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 803-814-2173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAbjuMLaj-IgR5lHsgNoGXaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_5064f6fd-b1d1-406f-936c-30446eb35830",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Dutch Square @ Broad River SuperStop",
      "poi_type": "Transportation & Transit",
      "poi_address": "St Andrews, SC 29210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1122948406177098045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-square--broad-river-superstop",
      "poi_latitude": "34.03500500000001",
      "poi_longitude": "-81.08924999999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-84D1mij-IgRPelGM6CDlQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_263f3c51-e139-4dfe-93d2-f1b66d2e054c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Quick Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "1330 Broad River Rd, Columbia, SC 29210, USA",
      "poi_short_description": "Convenience-store chain with snacks, soft drinks, candy, coffee & basic groceries.",
      "poi_long_description": "Convenience-store chain with snacks, soft drinks, candy, coffee & basic groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-3dda-7648-a917-4efaf00ca7a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-3dda-7648-a917-4efaf00ca7a9",
        "storage_key": "property/6737460151192643/019e1ddc-3dda-7648-a917-4efaf00ca7a9.webp",
        "width": 1280,
        "height": 1166
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16843199479193489031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quick-stop",
      "poi_latitude": "34.0289987",
      "poi_longitude": "-81.0848764",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 803-216-0802",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55d0-75c8-ae39-20fe68b2a37e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55d0-75c8-ae39-20fe68b2a37e",
        "storage_key": "property/6737460151192643/019e1ddc-55d0-75c8-ae39-20fe68b2a37e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJsbboZ12j-IgRh05f7q8Qv-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b0d2a1ae-faf7-481c-98f6-6cea5d1dca95",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Harbison State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5600 Broad River Rd, Columbia, SC 29212, USA",
      "poi_short_description": "Sprawling forest with 18 miles of hiking trails, a canoe landing, picnic shelters & a meeting space.",
      "poi_long_description": "Sprawling forest with 18 miles of hiking trails, a canoe landing, picnic shelters & a meeting space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-4148-76c2-9761-cf480d3413c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-4148-76c2-9761-cf480d3413c1",
        "storage_key": "property/6737460151192643/019e1ddc-4148-76c2-9761-cf480d3413c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.scfc.gov/state-forests/harbison-state-forest",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804040522832769827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harbison-state-forest",
      "poi_latitude": "34.0824612",
      "poi_longitude": "-81.13443120000001",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "138",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-896-8897",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX2455iii-IgRI3M_w__z6SY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_a2cf1c36-385a-4b85-b547-3ee5557da58b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "COMET Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1727 Sumter St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-454f-76da-9da4-ef5852bc52ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-454f-76da-9da4-ef5852bc52ac",
        "storage_key": "property/6737460151192643/019e1ddc-454f-76da-9da4-ef5852bc52ac.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://catchthecometsc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4433816841727021501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comet-central",
      "poi_latitude": "34.0094873",
      "poi_longitude": "-81.03573279999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-255-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJua8MJ4al-IgRvZFIGu0UiD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_098f6b34-952e-44fc-a9ac-43f0ebc2c392",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Columbia Metropolitan Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3250 Airport Blvd, West Columbia, SC 29170, USA",
      "poi_short_description": "Airport serving the Southeast & offering a range of commercial & charter flights.",
      "poi_long_description": "Airport serving the Southeast & offering a range of commercial & charter flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-42e4-76e4-a57b-7a73e1d108d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-42e4-76e4-a57b-7a73e1d108d2",
        "storage_key": "property/6737460151192643/019e1ddc-42e4-76e4-a57b-7a73e1d108d2.webp",
        "width": 1215,
        "height": 1280
      },
      "poi_business_url": "http://flycae.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7649969984303653536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-metropolitan-airport",
      "poi_latitude": "33.941917",
      "poi_longitude": "-81.1220015",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 803-822-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-55b1-7660-a677-a51c161293e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-55b1-7660-a677-a51c161293e8",
        "storage_key": "property/6737460151192643/019e1ddb-55b1-7660-a677-a51c161293e8.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RR4iMu9-IgRoOLRYCsnKmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_1fefd912-af14-4315-886f-e6043a61e55d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Lexington Park & Ride @ Corley Mill & Riverchase Way",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lexington, SC 29073, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1225093753409429517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lexington-park--ride--corley-mill--riverchase-way",
      "poi_latitude": "34.0133554",
      "poi_longitude": "-81.1504902",
      "poi_miles_from_property": "16.9",
      "poi_walking_minutes": "6 hours 16 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55cf-70bd-9c67-a8cfda2f9c6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55cf-70bd-9c67-a8cfda2f9c6d",
        "storage_key": "property/6737460151192643/019e1ddc-55cf-70bd-9c67-a8cfda2f9c6d.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1qGtyaj-IgRDeCEJEdoABE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_c848ae18-e49b-4b2a-addc-c5f28653f158",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Prisma Health Baptist Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Taylor at, Marion St, Columbia, SC 29220, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-439b-7198-82e4-891f5ce00174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-439b-7198-82e4-891f5ce00174",
        "storage_key": "property/6737460151192643/019e1ddc-439b-7198-82e4-891f5ce00174.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://prismahealth.org/locations/hospitals/baptist-hospital?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=729009320396996401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prisma-health-baptist-hospital",
      "poi_latitude": "34.0067651",
      "poi_longitude": "-81.0332239",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-296-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5328-7579-9e72-bd7efd38861b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5328-7579-9e72-bd7efd38861b",
        "storage_key": "property/6737460151192643/019e1ddb-5328-7579-9e72-bd7efd38861b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7RS6u9Wk-IgRMT82TB32HQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_c94ec6e1-aba4-4338-b8a0-f753543ba17a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Callcott Social Sciences Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "709 Bull St, Columbia, SC 29208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-4b20-72f2-b0e9-a02b312520ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-4b20-72f2-b0e9-a02b312520ed",
        "storage_key": "property/6737460151192643/019e1ddc-4b20-72f2-b0e9-a02b312520ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://artsandsciences.sc.edu/geog/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=11526265080838700405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "callcott-social-sciences-center",
      "poi_latitude": "33.9961971",
      "poi_longitude": "-81.0261548",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 803-777-5234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b8-7123-9086-ccefa97118bf",
        "storage_key": "property/6737460151192643/019e1ddb-52b8-7123-9086-ccefa97118bf.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwfn6yda6-IgRdT1hsgWF9Z8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "custom_f4682996-e236-4cf4-9f0f-3a6285660043",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Army Community Service Fort Jackson",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9810 Lee Rd, Columbia, SC 29206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-4b3b-7310-b11a-6c00be12b3c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-4b3b-7310-b11a-6c00be12b3c0",
        "storage_key": "property/6737460151192643/019e1ddc-4b3b-7310-b11a-6c00be12b3c0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://jackson.armymwr.com/programs/army",
      "poi_directions_map_url": "https://maps.google.com/?cid=14734911631717518700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "army-community-service-fort-jackson",
      "poi_latitude": "34.0171409",
      "poi_longitude": "-80.9247438",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 803-751-5256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6fv2UkCv-IgRbE1LZQ_sfMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_dad0fc6b-86bd-4a07-80fa-9cb1ffd8a335",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Lexington Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2720 Sunset Blvd, West Columbia, SC 29169, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dda-7fc0-7203-a695-f4cb651a5aba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-7fc0-7203-a695-f4cb651a5aba",
        "storage_key": "property/6737460151192643/019e1dda-7fc0-7203-a695-f4cb651a5aba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lexmed.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14880367824841087040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lexington-medical-center",
      "poi_latitude": "34.0067608",
      "poi_longitude": "-81.113531",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-791-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5328-7579-9e72-bd7efd38861b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5328-7579-9e72-bd7efd38861b",
        "storage_key": "property/6737460151192643/019e1ddb-5328-7579-9e72-bd7efd38861b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2SkcNS8-IgRQBjOdrKvgc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_88aef60b-ec73-405d-9d25-10dc8492b216",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "South Carolina Department of Transportation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "955 Park St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-4bda-703c-83e8-bc782ddcf8ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-4bda-703c-83e8-bc782ddcf8ba",
        "storage_key": "property/6737460151192643/019e1ddc-4bda-703c-83e8-bc782ddcf8ba.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://scdotmidlandsconnection.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3477631849670717738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-department-of-transportation",
      "poi_latitude": "33.9966245",
      "poi_longitude": "-81.0357657",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlUTgPym7-IgRKjE1870HQzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_127eb27b-bd42-4e5f-bb8e-ff0670e5b873",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "S.C. Department of Health and Environmental Control: Administrative Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2100 Bull St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dph.sc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15645336916529908183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sc-department-of-health-and-environmental-control-administrative-offices",
      "poi_latitude": "34.0142561",
      "poi_longitude": "-81.0324833",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-898-3432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55fa-7160-ae51-256e75dac55c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55fa-7160-ae51-256e75dac55c",
        "storage_key": "property/6737460151192643/019e1ddc-55fa-7160-ae51-256e75dac55c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY2z489ek-IgR1wkSdQhnH9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_62fac426-3366-47f3-bf73-9f868c54ab2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Blue Cross & Blue Shield of SC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 Faraway Dr, Columbia, SC 29223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-4bdb-7208-88d6-0f4771bf24ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-4bdb-7208-88d6-0f4771bf24ad",
        "storage_key": "property/6737460151192643/019e1ddc-4bdb-7208-88d6-0f4771bf24ad.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.southcarolinablues.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9984890566457078718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-cross--blue-shield-of-sc",
      "poi_latitude": "34.0677747",
      "poi_longitude": "-80.9146859",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-288-2227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52c3-73e8-90f6-007a607ce0d1",
        "storage_key": "property/6737460151192643/019e1ddb-52c3-73e8-90f6-007a607ce0d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTb04Db-u-IgRvrPSZhF1kYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2a1bab1c-500d-44cc-9a1f-762549a9c724",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Richland County Administrative",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2020 Hampton St, Columbia, SC 29204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.richlandcountysc.gov/Government/Departments/Executive/Administration",
      "poi_directions_map_url": "https://maps.google.com/?cid=15388324085270599653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richland-county-administrative",
      "poi_latitude": "34.0085905",
      "poi_longitude": "-81.0209587",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-576-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55fa-7160-ae51-256e75dac55c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55fa-7160-ae51-256e75dac55c",
        "storage_key": "property/6737460151192643/019e1ddc-55fa-7160-ae51-256e75dac55c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfl74i2l-IgR5VckhzlPjtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_7b46edbf-c8a3-40cf-826d-824c734b1c8e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "William Jennings Bryan Dorn Veterans Affairs Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6439 Garners Ferry Rd, Columbia, SC 29209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-4f59-7542-8fa1-57d01ad1a61a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-4f59-7542-8fa1-57d01ad1a61a",
        "storage_key": "property/6737460151192643/019e1ddc-4f59-7542-8fa1-57d01ad1a61a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.columbiasc.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15102862645337255401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-jennings-bryan-dorn-veterans-affairs-medical-center",
      "poi_latitude": "33.9754103",
      "poi_longitude": "-80.95970340000001",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 803-776-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddc-55fa-7160-ae51-256e75dac55c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddc-55fa-7160-ae51-256e75dac55c",
        "storage_key": "property/6737460151192643/019e1ddc-55fa-7160-ae51-256e75dac55c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuajvej-w-IgR6e3Xuo4lmNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0a361dab-c495-40d1-9383-02ea4dedcb32",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Hampton-Preston Mansion and Gardens",
      "poi_type": "Entertainment",
      "poi_address": "1615 Blanding St, Columbia, SC 29201, USA",
      "poi_short_description": "1818 family residence & onetime governor's mansion open for tours of interior & surrounding gardens.",
      "poi_long_description": "Visitors say this historic mansion features beautifully kept gardens with a variety of native and unique plant species, and a restored historic home with antique furniture. They also highlight the peaceful atmosphere, ample shade, and convenient free street parking. Guests mention it's an excellent location for special events like weddings and photoshoots, and appreciate the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019ea832-b4e0-767c-a723-e3b3b01c6b54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea832-b4e0-767c-a723-e3b3b01c6b54",
        "storage_key": "property/6737460151192643/019ea832-b4e0-767c-a723-e3b3b01c6b54.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.historiccolumbia.org/hampton-preston-mansion-and-gardens",
      "poi_directions_map_url": "https://maps.google.com/?cid=7297446809818697081&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hampton-preston-mansion-and-gardens",
      "poi_latitude": "34.0105056",
      "poi_longitude": "-81.0294437",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-252-7742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-52b5-744e-8306-c281c75c7e21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-52b5-744e-8306-c281c75c7e21",
        "storage_key": "property/6737460151192643/019e1ddb-52b5-744e-8306-c281c75c7e21.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49nnlyml-IgReQ2NwjW9RWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bf00a359-1bc4-4448-8102-09a2a43c6bb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "West Columbia Riverwalk Park and Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "109 Alexander Rd, West Columbia, SC 29169, USA",
      "poi_short_description": "This park on the Congaree River features an amphitheater & connects with the Three Rivers Greenway.",
      "poi_long_description": "People say this riverwalk offers beautiful, peaceful, and shaded walking and biking trails with great views of the river. They also highlight the clean and well-kept facilities, including spotless restrooms. Visitors appreciate the free parking and the option to rent tubes for river floating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-3cbf-701e-8a02-4dad340cb186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddb-3cbf-701e-8a02-4dad340cb186",
        "storage_key": "property/6737460151192643/019e1ddb-3cbf-701e-8a02-4dad340cb186.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://westcolumbiasc.gov/recreation/riverwalk-park-amphitheater/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13424275961736358566&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "west-columbia-riverwalk-park-and-amphitheater",
      "poi_latitude": "33.9947003",
      "poi_longitude": "-81.0529644",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-791-1880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-53c9-75fe-a720-c392c36624ae",
        "storage_key": "property/6737460151192643/019e1ddb-53c9-75fe-a720-c392c36624ae.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcFG-ze7-IgRpmocwtybTLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_941002c6-6e8b-4baf-8dcb-0d72ad8bddda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Soda City Market",
      "poi_type": "Entertainment",
      "poi_address": "1300-1700 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Lively Saturday gathering of trendy food trucks & tented stalls offering locally made wares.",
      "poi_long_description": "People say this market offers a huge variety of food, drinks, and unique crafts from local vendors, including international cuisine and fresh flowers. Visitors highlight the lively atmosphere with live music and street performers, making it a fun way to spend a Saturday morning. They also appreciate the friendly staff and the opportunity to support local businesses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019ea832-b35c-76f8-9c28-0774e6b37718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea832-b35c-76f8-9c28-0774e6b37718",
        "storage_key": "property/6737460151192643/019ea832-b35c-76f8-9c28-0774e6b37718.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sodacitysc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2842810751571818959&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "soda-city-market",
      "poi_latitude": "34.0028149",
      "poi_longitude": "-81.03384609999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddb-5373-7738-9788-c62bf00791a5",
        "storage_key": "property/6737460151192643/019e1ddb-5373-7738-9788-c62bf00791a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJd_pxFiG7-IgRz3kZE1Gxcyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_49f3fe95-f6f8-4071-a6eb-bfbfdd568012",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "The Vista Columbia",
      "poi_type": "Shopping & Retail",
      "poi_address": "701 Gervas St Columbia, SC 29201",
      "poi_short_description": "Shops and Restaurants along Gervais Street",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "www.vistacolumbia.com",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23b591ae-3bc0-40b1-81e6-89864de9ddc5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Icehouse Amphitheater",
      "poi_type": "Restaurants",
      "poi_address": "107 W Main St. Lexington, SC 29072",
      "poi_short_description": "Live music, fresh market, dining",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "www.icehouseamphitheater.com",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a926aaa8-ed0d-4c82-91af-5baa169c9f66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "USC Athletics ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "",
      "poi_short_description": "SEC Football, basketball and baseball",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://gamecocksonline.com/",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f33e019-cb51-4f22-9f8d-71a31bf25f7b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "custom",
      "poi_name": "Columbia Fireflies",
      "poi_type": "Entertainment",
      "poi_address": "1640 Freed St Columbia, SC 29201",
      "poi_short_description": "Minor League baseball",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.milb.com/columbia",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f2a83cfa93ece2936bcab72c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_887e4c07fb663b8eb1e1e73a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a059adb89c9fa0af4bebee9f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6b71ecff468fad0164722391",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f4f55014f61dfb5246c995c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_eb02c56e-4d18-4137-b810-3e73630c1a5f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "rating": "5",
      "name": "Kendall Nelson",
      "text": "I've lived here for a year so far, and just resigned my lease. The front office is always helpful and easy to get ahold of if needed. The maintenance guys are also great, they've always been helpful but I've only had to put in 2 requests. The grounds are very pretty (love the pond and pool) and well kept, I think this apartment complex is a little hidden gem in Columbia. It is mostly young professionals and families that live here so its quiet and safe!",
      "date": "2026-05-08",
      "title": "false"
    },
    {
      "id": "custom_0885de5e-9673-4432-9b40-364b9f0ff5de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "rating": "5",
      "name": "Neozia Scott",
      "text": "i talked to kaiia during my process and she was great! she answered every question with confidence and accuracy!",
      "date": "2026-03-27",
      "title": "false"
    },
    {
      "id": "custom_d5e012b0-d230-4137-90b4-5633c9e5a090",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "rating": "5",
      "name": "Mimi Elaine",
      "text": "I lived here for 6 years and have nothing but lovely things to say. The area is safe and quiet. The front office ladies Kristie and Lynn are humans that truly care about their tenenants and go above and beyond for them. The maintenence is FAST. If my apartment hadnt burned down (no fault of the complex) I could of stayed there forever. Will miss living here so much.",
      "date": "2026-02-20",
      "title": "false"
    },
    {
      "id": "custom_88cd0bd2-fb08-42c4-a305-b172cc4fbaaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "rating": "5",
      "name": "Zebrandon",
      "text": "My experience with peach tree has been amazing..10/10 recommend if your looking for a place leesa has made this experience easy and she is amazing!!!",
      "date": "2025-11-14",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_2d3ccce329a96c4c0ea6be7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd9-eb0d-77f7-a06f-d64065bee080",
        "storage_key": "property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=667a19eddbb401434519282b&c=0"
    },
    {
      "id": "ec_466d080cba127a6ca7b7d768",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd9-eb0d-77f7-a06f-d64065bee080",
        "storage_key": "property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=667a19eddbb401434519282b&c=1"
    },
    {
      "id": "ec_3d423f5603abece8ed308514",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd9-eb0d-77f7-a06f-d64065bee080",
        "storage_key": "property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Leasing",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=667a19eddbb401434519282b&c=2"
    },
    {
      "id": "ec_4450416e659d337c486abeca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd9-eb0d-77f7-a06f-d64065bee080",
        "storage_key": "property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=667a19eddbb401434519282b&c=3"
    },
    {
      "id": "ec_65b13042a47ee3952d06845b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd9-eb0d-77f7-a06f-d64065bee080",
        "storage_key": "property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=667a19eddbb401434519282b&c=4"
    },
    {
      "id": "ec_97508e95be66ea838e8826ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd9-eb0d-77f7-a06f-d64065bee080",
        "storage_key": "property/6737460151192643/019e1dd9-eb0d-77f7-a06f-d64065bee080.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Patio",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://v1.panoskin.com/?tour=667a19eddbb401434519282b&c=5"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e1d-f17b-70d8-a0cb-cdb0fff6fcd7",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-broad-river-trace-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643"
    },
    {
      "lead_collector_id": "019a1864-78d8-77fb-95e0-c9b98d176dec",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-broad-river-trace-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "generator",
      "page_item_url": "broad-river-trace-apartments-with-pool-columbia-sc",
      "search_query": "apartments with pool Columbia SC",
      "category": "Amenity",
      "h1_title": "Discover Apartments with Pool in Columbia SC",
      "h2_subtitle": "Experience the thrill of living at Broad River Trace with a sparkling pool. Dive into relaxation at our Columbia SC apartments featuring a stunning pool.",
      "page_copy": "Nestled in the heart of Columbia, SC, Broad River Trace offers attractive apartments with pool amenities that promise to elevate your living experience. Choose from our charming one, two, or three-bedroom options designed with modern comforts and conveniences. Imagine spending your sunny afternoons by our refreshing pool, perfect for unwinding and socializing. The pet-friendly atmosphere, complete with a specifically designed pet park, ensures everyone feels at home.\n\nBeyond the pool, residents enjoy an array of desirable features including vinyl flooring and a gas fire pit for cozy evenings. Stay active with access to our 24-hour fitness center and enjoy the peace of mind provided by ample parking and controlled access. Situated in the vibrant St Andrews neighborhood, Broad River Trace not only offers a stunning pool but also the convenience and lifestyle you desire.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets and marble countertops.",
        "public_id": "019d0784-c794-765f-a451-7f43b6157976",
        "storage_key": "property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Columbia SC",
      "seo_description": "Dive into luxury at Broad River Trace's apartments with a pool in Columbia SC. Enjoy vibrant living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "generator",
      "page_item_url": "broad-river-trace-pet-friendly-apartments-richland-county",
      "search_query": "pet-friendly apartments in Richland County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Richland County",
      "h2_subtitle": "Discover the ideal pet-friendly lifestyle at Broad River Trace. Our Richland County apartments welcome you and your furry friends.",
      "page_copy": "Experience comfortable living for both you and your pets at Broad River Trace, situated in the heart of Richland County. Our pet-friendly apartments offer spacious one, two, or three-bedroom layouts, providing ample room for everyone. The on-site pet park ensures that your furry companions have space to play and socialize, making it a perfect home for animal lovers.\n\nApart from our exceptional pet-friendly amenities, residents enjoy a variety of other features that make life here delightful. Take advantage of our satellite TV, cable-ready units, and vinyl flooring that offer convenience and style. Whether you're working out in our 24-hour fitness center or enjoying a break by the pool, Broad River Trace balances comfort and community in the vibrant St Andrews neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets and marble countertops.",
        "public_id": "019d0784-c794-765f-a451-7f43b6157976",
        "storage_key": "property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Richland County",
      "seo_description": "Find pet-friendly apartments in Richland County at Broad River Trace, offering comfortable living for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "generator",
      "page_item_url": "broad-river-trace-fitness-center-apartments-st-andrews",
      "search_query": "fitness center apartments St Andrews",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in St Andrews",
      "h2_subtitle": "Stay fit and active at Broad River Trace. Our St Andrews apartments feature a 24-hour fitness center and more.",
      "page_copy": "At Broad River Trace, staying active is easy with our modern 24-hour fitness center, making us a prime choice for fitness enthusiasts in St Andrews. These thoughtfully designed one, two, and three-bedroom apartments provide both comfort and convenience, ensuring you have everything you need within reach. Whether you prefer morning workouts or late-night sessions, our fitness center accommodates any schedule.\n\nIn addition to the gym, the community boasts a sparkling pool and ample recreational opportunities that cater to a balanced lifestyle. Enjoy evenings around the gas fire pit or spend quality time with your pet in our dedicated pet park. Located in the dynamic St Andrews neighborhood of Columbia, SC, Broad River Trace offers the perfect blend of relaxation and activity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets and marble countertops.",
        "public_id": "019d0784-c794-765f-a451-7f43b6157976",
        "storage_key": "property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in St Andrews",
      "seo_description": "Enjoy a 24-hour fitness center at Broad River Trace in St Andrews, offering apartments that cater to an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "generator",
      "page_item_url": "broad-river-trace-gated-community-29210",
      "search_query": "Broad River Trace gated community 29210",
      "category": "Amenity",
      "h1_title": "Broad River Trace: Gated Community 29210",
      "h2_subtitle": "Experience tranquility and security at Broad River Trace, a gated community in the 29210 area. Our Columbia, SC apartments offer peace of mind.",
      "page_copy": "Welcome to Broad River Trace, a premier gated community in the 29210 area, where security and peace of mind are paramount. Located in Columbia, SC, this community provides a variety of one, two, and three-bedroom apartments, each designed with comfort and modern amenities in mind. Our controlled access enhances resident safety, ensuring a serene living environment.\n\nIn addition to the benefits of gated living, enjoy our resort-style amenities including a sparkling pool, satellite TV, and cable-ready units. The community is pet-friendly, featuring a dedicated pet park, and offers a variety of activities with a gas fire pit and a fully-equipped 24-hour fitness center. Discover the perfect blend of convenience and security at Broad River Trace in Richland County’s 29210 zip code.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets and marble countertops.",
        "public_id": "019d0784-c794-765f-a451-7f43b6157976",
        "storage_key": "property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Broad River Trace: Gated Community in 29210",
      "seo_description": "Discover Broad River Trace, a gated community in Columbia's 29210. Enjoy modern living with security and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-near-broad-river-trace",
      "search_query": "apartments with air conditioning near Broad River Trace",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning Near Broad River Trace",
      "h2_subtitle": "Stay cool in Columbia, SC, with our air-conditioned apartments near Broad River Trace. Comfort and climate control at its best.",
      "page_copy": "Finding a comfortable home is easy with our air-conditioned apartments located near Broad River Trace. Ideal for Columbia's warm climate, these well-equipped one, two, and three-bedroom units ensure you're always cool and relaxed. Whether you're spending a quiet day at home or returning after a workout in our 24-hour fitness center, enjoy the perfect indoor environment year-round.\n\nIn addition to climate-controlled living spaces, residents can indulge in various community amenities. Relax by the stunning pool, socialize with neighbors around the gas fire pit, or let your pets roam free in our dedicated pet park. Conveniently located in the vibrant St Andrews area, our community offers both excellent amenities and a peaceful living experience near Broad River Trace.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets and marble countertops.",
        "public_id": "019d0784-c794-765f-a451-7f43b6157976",
        "storage_key": "property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "A/C Apartments Near Broad River Trace",
      "seo_description": "Find air-conditioned apartments near Broad River Trace in Columbia, SC, offering comfort and top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-columbia-sc-broad-river-trace",
      "search_query": "two bedroom apartments in Columbia SC",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Columbia, SC",
      "h2_subtitle": "Discover spacious two bedroom apartments at Broad River Trace in Columbia, SC. Perfect for your modern lifestyle needs.",
      "page_copy": "At Broad River Trace, you'll find well-appointed two bedroom apartments in Columbia, SC, designed to cater to your every need. These residences offer ample space and modern conveniences that create a perfect backdrop for comfortable living. Whether you're a small family or a couple wanting extra room, our apartments provide the ideal balance of style and functionality.\n\nIn addition to spacious interiors, residents enjoy various community amenities. Take advantage of the resort-style pool, gas fire pit, and vinyl flooring that adds a touch of elegance. A 24-hour fitness center is available to maintain an active lifestyle, and broad community access ensures peace and safety. Located in vibrant St Andrews, Broad River Trace is a place you'll be proud to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets and marble countertops.",
        "public_id": "019d0784-c794-765f-a451-7f43b6157976",
        "storage_key": "property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Columbia, SC",
      "seo_description": "Spacious two bedroom apartments at Broad River Trace in Columbia, SC, offer modern amenities and a vibrant community environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-st-andrews-broad-river-trace",
      "search_query": "one bedroom apartments in St Andrews",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in St Andrews",
      "h2_subtitle": "Explore cozy one bedroom apartments at Broad River Trace, nestled in the St Andrews neighborhood. Columbia living at its finest.",
      "page_copy": "Nestled in the charming St Andrews neighborhood, Broad River Trace offers an inviting selection of one bedroom apartments perfect for singles or couples. These units seamlessly combine comfort and style, providing an ideal retreat after a busy day. With modern design elements and efficient layouts, each apartment reflects the allure of Columbia living.\n\nEnjoy on-site amenities like a sparkling pool, cable-ready options, and a pet park for your four-legged friends. Meanwhile, a gas fire pit adds a touch of outdoor charm, perfect for evenings under Columbia's sky. Whether you're using the convenience of vinyl flooring or enjoying the ample parking spaces, Broad River Trace in St Andrews is where comfort meets convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets and marble countertops.",
        "public_id": "019d0784-c794-765f-a451-7f43b6157976",
        "storage_key": "property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in St Andrews",
      "seo_description": "Discover cozy one bedroom apartments in St Andrews at Broad River Trace. Enjoy modern living with top amenities in Columbia, SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192643",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-richland-county-broad-river-trace",
      "search_query": "three bedroom apartments near Richland County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Richland County",
      "h2_subtitle": "Find spacious three bedroom apartments near Richland County at Broad River Trace. Ideal for family living in Columbia, SC.",
      "page_copy": "Broad River Trace presents generously sized three bedroom apartments ideally situated near Richland County, offering an excellent living solution for families or roommates. These thoughtfully designed apartments boast ample room for everyone, making them perfect for a comfortable and harmonious household. Experience Columbia, SC, living with the added benefit of spacious bedrooms, modern amenities, and a welcoming community.\n\nThe property's rich set of amenities includes a resort-style pool, satellite TV, and a dedicated pet park for your furry companions. Convenient vinyl flooring adds an extra level of sophistication, while controlled access and ample parking provide peace of mind. Located in the vibrant St Andrews area, our apartments near Richland County ensure you're close to everything you need while providing a serene retreat from the city's hustle and bustle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with white cabinets and marble countertops.",
        "public_id": "019d0784-c794-765f-a451-7f43b6157976",
        "storage_key": "property/6737460151192643/019d0784-c794-765f-a451-7f43b6157976.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Richland County",
      "seo_description": "Explore spacious three bedroom apartments near Richland County at Broad River Trace in Columbia, SC, offering superb amenities and community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3365"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483269"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5026473"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PBWZJ6TK"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "803-353-5454"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bil_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=bil"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "803-770-4946"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "803-618-4216"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "803-220-3791"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "803-897-9032"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "803-676-1615"
    },
    {
      "ID": "custom_knock_bil_title",
      "type": "STRING",
      "value": "Billboard"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "803-784-3366"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "803-971-4556"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "803-879-2145"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "803-855-1751"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "803-784-7687"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bil_number",
      "type": "STRING",
      "value": "803-941-5405"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "803-770-4559"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "803-902-7211"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "803-715-5835"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "803-598-3045"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "803-859-4228"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "803-991-7027"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "803-653-6450"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321225804"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "803-672-6461"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "803-839-0485"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1ee59f26a521c3b1"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "803-903-5468"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "803-599-3018"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "803-674-4925"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "803-836-4231"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "803-752-3151"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "803-882-9096"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "803-353-5778"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.broadrivertrace.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192643/019e60df-d5ec-71ce-87a5-5bf434dfe766.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "803-291-9120"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "803-855-1751"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3365",
  "custom_repli_id": "5028483269",
  "custom_realpage_id": "5026473",
  "custom_knock_a_link": "https://www.broadrivertrace.com?utm_knock=a",
  "custom_knock_g_link": "https://www.broadrivertrace.com?utm_knock=g",
  "custom_knock_r_link": "https://www.broadrivertrace.com?utm_knock=r",
  "custom_knock_w_link": "https://www.broadrivertrace.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-PBWZJ6TK",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.broadrivertrace.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.broadrivertrace.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.broadrivertrace.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.broadrivertrace.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.broadrivertrace.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.broadrivertrace.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "803-353-5454",
  "custom_knock_ads_link": "https://www.broadrivertrace.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bil_link": "https://www.broadrivertrace.com?utm_knock=bil",
  "custom_knock_bnr_link": "https://www.broadrivertrace.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "803-770-4946",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.broadrivertrace.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.broadrivertrace.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.broadrivertrace.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.broadrivertrace.com?utm_knock=psa",
  "custom_knock_r_number": "803-618-4216",
  "custom_knock_w_number": "803-220-3791",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "803-897-9032",
  "custom_knock_amap_link": "https://www.broadrivertrace.com?utm_knock=amap",
  "custom_knock_ar_number": "803-676-1615",
  "custom_knock_bil_title": "Billboard",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "803-784-3366",
  "custom_knock_fb_number": "803-971-4556",
  "custom_knock_fl_number": "803-879-2145",
  "custom_knock_gp_number": "803-855-1751",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.broadrivertrace.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "803-784-7687",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.broadrivertrace.com?utm_knock=bcard",
  "custom_knock_bil_number": "803-941-5405",
  "custom_knock_bnr_number": "803-770-4559",
  "custom_knock_cfres_link": "https://www.broadrivertrace.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "803-902-7211",
  "custom_knock_lgp_number": "803-715-5835",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.broadrivertrace.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "803-598-3045",
  "custom_knock_psa_number": "803-859-4228",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "803-991-7027",
  "custom_knock_bandit_link": "https://www.broadrivertrace.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.broadrivertrace.com?utm_knock=flyers",
  "custom_knock_osoc_number": "803-653-6450",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321225804",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "803-672-6461",
  "custom_knock_cfres_number": "803-839-0485",
  "custom_knock_chatgpt_link": "https://www.broadrivertrace.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1ee59f26a521c3b1",
  "custom_knock_dirmail_link": "https://www.broadrivertrace.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "803-903-5468",
  "custom_knock_propbro_link": "https://www.broadrivertrace.com?utm_knock=propbro",
  "custom_knock_bandit_number": "803-599-3018",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "803-674-4925",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.broadrivertrace.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "803-836-4231",
  "custom_knock_dirmail_number": "803-752-3151",
  "custom_knock_propbro_number": "803-882-9096",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "803-353-5778",
  "custom_knock_maintenance_link": "https://www.broadrivertrace.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192643/019e60df-d5ec-71ce-87a5-5bf434dfe766.mp4",
  "custom_knock_maintenance_number": "803-291-9120",
  "custom_ppc_tracking_phone_number": "803-855-1751"
};

export const generatedAt = '2026-10-07T17:12:06.946Z';
